var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/AdflowAPI.ts
var AdflowAPI_exports = {};
__export(AdflowAPI_exports, {
  AdElementCasinoAssetSchema: () => AdElementCasinoAssetSchema,
  AdElementDataSourceSchema: () => AdElementDataSourceSchema,
  AdElementImageSchema: () => AdElementImageSchema,
  AdElementSVGSchema: () => AdElementSVGSchema,
  AdElementSchema: () => AdElementSchema,
  AdElementTeamAssetSchema: () => AdElementTeamAssetSchema,
  AdElementTextSchema: () => AdElementTextSchema,
  AdElementTypeSchema: () => AdElementTypeSchema,
  AdElementVectorSchema: () => AdElementVectorSchema,
  AdTemplateCasinoImageOrientationSchema: () => AdTemplateCasinoImageOrientationSchema,
  AdTemplateDataSourceSchema: () => AdTemplateDataSourceSchema,
  AdTemplateDataSourcesSchema: () => AdTemplateDataSourcesSchema,
  AdTemplateDiplayOptionsSchema: () => AdTemplateDiplayOptionsSchema,
  AdTemplateSchema: () => AdTemplateSchema,
  AdTemplateTypeSchema: () => AdTemplateTypeSchema,
  AnimatablePropertySchema: () => AnimatablePropertySchema,
  AnimationEffectSchema: () => AnimationEffectSchema,
  AnimationKeyframeSchema: () => AnimationKeyframeSchema,
  AnimationSchema: () => AnimationSchema,
  AnimationTimelineSchema: () => AnimationTimelineSchema,
  AnimationTrackSchema: () => AnimationTrackSchema,
  BusinessEntitySchema: () => BusinessEntitySchema,
  CanonicalEasingSchema: () => CanonicalEasingSchema,
  CountdownFormatStyleSchema: () => CountdownFormatStyleSchema,
  CountdownTimeGranularitySchema: () => CountdownTimeGranularitySchema,
  DateTimeFormatSchema: () => DateTimeFormatSchema,
  DiplayOptionsTeamAssetSchema: () => DiplayOptionsTeamAssetSchema,
  DisplayOptionsOddsFormatSchema: () => DisplayOptionsOddsFormatSchema,
  FigmaComponentSchema: () => FigmaComponentSchema,
  FigmaComponentSizeSchema: () => FigmaComponentSizeSchema,
  FigmaComponentsListOutputSchema: () => FigmaComponentsListOutputSchema,
  FontFaceExtendedSchema: () => FontFaceExtendedSchema,
  FontFaceSchema: () => FontFaceSchema,
  HierarchyLayoutEntrySchema: () => HierarchyLayoutEntrySchema,
  HierarchyNodeSchema: () => HierarchyNodeSchema,
  HierarchyNodeTypeSchema: () => HierarchyNodeTypeSchema,
  HierarchySchema: () => HierarchySchema,
  HierarchyTransformSchema: () => HierarchyTransformSchema,
  HoldingSchema: () => HoldingSchema,
  ImportSourceTypeEnum: () => ImportSourceTypeEnum,
  PenaltiesFormatSchema: () => PenaltiesFormatSchema,
  isCasinoAssetElement: () => isCasinoAssetElement,
  isDisplayOptionsOddsType: () => isDisplayOptionsOddsType,
  isImageElement: () => isImageElement,
  isSVGElement: () => isSVGElement,
  isTeamAssetElement: () => isTeamAssetElement,
  isTextElement: () => isTextElement,
  isVectorElement: () => isVectorElement
});

// ../../node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: issueData.message || errorMessage
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      syncPairs.push({
        key: await pair.key,
        value: await pair.value
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  constructor() {
    super(...arguments);
    this._regex = (regex, validation, message) => this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
    this.nonempty = (message) => this.min(1, errorUtil.errToObj(message));
    this.trim = () => new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
    this.toLowerCase = () => new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
    this.toUpperCase = () => new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _addCheck(check) {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  var _a;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
    ...processCreateParams(params)
  });
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip")
        ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          syncPairs.push({
            key,
            value: await pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue, ctx) => {
          var _a, _b, _c, _d;
          const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new _ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest
    });
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new _ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return _ZodEnum.create(values);
  }
  exclude(values) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    if (isValid(result)) {
      result.value = Object.freeze(result.value);
    }
    return result;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
var custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
      }
    });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true })
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// src/Datasources.ts
var Datasources_exports3 = {};
__export(Datasources_exports3, {
  AllEventDataPointNameSchema: () => AllEventDataPointNameSchema,
  DataSource: () => DataSource,
  DataTypeSchema: () => DataTypeSchema,
  RecommendersDataSources: () => Datasources_exports,
  SPORTS_MOMENTS_SOURCE_TYPES: () => SPORTS_MOMENTS_SOURCE_TYPES,
  STAGE_MARKET_SOURCE_TYPES: () => STAGE_MARKET_SOURCE_TYPES,
  SourceTypeSchema: () => SourceTypeSchema,
  availableMarketTypesForCompetition: () => availableMarketTypesForCompetition,
  buildImportDataSourceTypes: () => buildImportDataSourceTypes,
  carRacingStageSelectOptions: () => carRacingStageSelectOptions,
  competitions: () => competitions2,
  createDataSourceDefinitions: () => createDataSourceDefinitions,
  dataSourceDefinition: () => dataSourceDefinition,
  dataSourcesConfigs: () => dataSourcesConfigs3,
  dataTypes: () => dataTypes,
  filterImportDataSourceSuggestions: () => filterImportDataSourceSuggestions,
  filterNonSoccerSportsSuggestions: () => filterNonSoccerSportsSuggestions,
  filterNonSoccerTemplates: () => filterNonSoccerTemplates,
  filterNonSportsMomentsTemplates: () => filterNonSportsMomentsTemplates,
  filterOtherSportsMomentsSuggestions: () => filterOtherSportsMomentsSuggestions,
  filterToNBACommonOnly: () => filterToNBACommonOnly,
  filterToNBAStage: () => filterToNBAStage,
  filterToNFLCommonOnly: () => filterToNFLCommonOnly,
  filterToNFLStage: () => filterToNFLStage,
  filterToSoccerCommonOnly: () => filterToSoccerCommonOnly,
  filterToSoccerStage: () => filterToSoccerStage,
  friendlyDataPointName: () => friendlyDataPointName,
  getDataTypeFromSourceType: () => getDataTypeFromSourceType,
  getFriendlySourceNameFromSourceType: () => getFriendlySourceNameFromSourceType,
  getIconNameForSourceType: () => getIconNameForSourceType,
  getImportDataSourceCompetitionOptions: () => getImportDataSourceCompetitionOptions,
  getImportDataSourceConfirmationMessage: () => getImportDataSourceConfirmationMessage,
  getImportDataSourceDisplayDetails: () => getImportDataSourceDisplayDetails,
  getImportDataSourceFamilyLabel: () => getImportDataSourceFamilyLabel,
  getImportDataSourceFamilyOptions: () => getImportDataSourceFamilyOptions,
  getImportDataSourceStageOptions: () => getImportDataSourceStageOptions,
  inferImportDataSourceConfig: () => inferImportDataSourceConfig,
  inferSoccerMomentsConfig: () => inferSoccerMomentsConfig,
  isCompetitorFilter: () => isCompetitorFilter,
  isCompetitorFocusedPoint: () => isCompetitorFocusedPoint,
  isMarketDataType: () => isMarketDataType,
  mergeTextElementSources: () => mergeTextElementSources,
  newSourceTypes: () => newSourceTypes,
  parseDataPointName: () => parseDataPointName,
  pickSuggestionGroupForElementImport: () => pickSuggestionGroupForElementImport,
  resolveImportDataSourceConfig: () => resolveImportDataSourceConfig,
  resolveInlineTokensInContent: () => resolveInlineTokensInContent,
  resolveLayerNameToDataPoint: () => resolveLayerNameToDataPoint,
  resolveTextElementTokens: () => resolveTextElementTokens,
  resolveTokenToDataPoint: () => resolveTokenToDataPoint,
  sourceTypeToNormalisedMarketName: () => sourceTypeToNormalisedMarketName,
  sourceTypes: () => sourceTypes3,
  sportsMomentsCompetitionNames: () => sportsMomentsCompetitionNames2,
  suggestDataSources: () => suggestDataSources,
  summarizeSuggestedDataSources: () => summarizeSuggestedDataSources,
  teamImagesMappingConfigs: () => teamImagesMappingConfigs2,
  textElementDataPoints: () => textElementDataPoints
});

// ../../node_modules/nanoid/non-secure/index.js
var urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
var nanoid = (size = 21) => {
  let id = "";
  let i = size | 0;
  while (i-- > 0) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/Recommenders/Datasources.ts
var Datasources_exports = {};
__export(Datasources_exports, {
  combinedDP: () => combinedDP,
  dataSourcesConfigs: () => dataSourcesConfigs,
  mapDataTypesFromSourceTypes: () => mapDataTypesFromSourceTypes,
  normalisedMarketNames: () => normalisedMarketNames,
  recommendersFriendlyNameFromSourceTypeMap: () => recommendersFriendlyNameFromSourceTypeMap,
  recommendersIconMap: () => recommendersIconMap,
  recommendersMarketDataTypes: () => recommendersMarketDataTypes,
  recommendersTypeMap: () => recommendersTypeMap,
  sourceTypes: () => sourceTypes,
  teamImagesMappingConfigs: () => teamImagesMappingConfigs
});

// src/Recommenders/Event/index.ts
var typeName = "EVENT";
var dataPointNames = [
  "EVENT_NAME",
  "HOME_NAME",
  "AWAY_NAME",
  "HOME_NAME_MICRO",
  "AWAY_NAME_MICRO",
  "MARKET_NAME",
  "HOME_ODDS",
  "AWAY_ODDS",
  "DRAW_ODDS",
  "COMPETITION_NAME",
  "DATE",
  "TIME",
  "COMPETITOR_ID",
  "PROMO_ODDS",
  "PROMO_WAS_ODDS",
  "PROMO_TEXT",
  "SPORT"
];
var dataPoints = [
  { name: "EVENT_NAME", type: "TEXT" },
  { name: "HOME_NAME", type: "TEXT" },
  { name: "AWAY_NAME", type: "TEXT" },
  { name: "HOME_NAME_MICRO", type: "TEXT" },
  { name: "AWAY_NAME_MICRO", type: "TEXT" },
  { name: "MARKET_NAME", type: "TEXT" },
  { name: "HOME_ODDS", type: "TEXT" },
  { name: "AWAY_ODDS", type: "TEXT" },
  { name: "DRAW_ODDS", type: "TEXT" },
  { name: "COMPETITION_NAME", type: "TEXT" },
  { name: "TIME", type: "TEXT" },
  { name: "DATE", type: "TEXT" },
  { name: "PROMO_ODDS", type: "TEXT" },
  { name: "PROMO_WAS_ODDS", type: "TEXT" },
  { name: "PROMO_TEXT", type: "TEXT" },
  { name: "SPORT", type: "TEXT" },
  { name: "COMPETITOR_ID", type: "TEAM_ASSET" }
];
var dataSourceConfig = {
  name: "Event",
  points: dataPoints,
  dataType: "TEMPLATE",
  type: typeName
};

// src/Recommenders/GenericTemplate/index.ts
var dataPointNames2 = [
  "DAY",
  "DATE",
  "MONTH",
  "TIME",
  "COUNTDOWN",
  "SPORT_NAME",
  "SPORT_ID",
  "COMPETITOR_ID",
  "HOME_COMPETITOR_ID",
  "AWAY_COMPETITOR_ID",
  "HOME_COMPETITOR_COUNTRY_CODE",
  "AWAY_COMPETITOR_COUNTRY_CODE",
  "COMPETITION_ID",
  "COMPETITION_NAME",
  "EVENT_NAME",
  "HOME_NAME",
  "AWAY_NAME",
  "HOME_NAME_MICRO",
  "AWAY_NAME_MICRO",
  "VENUE",
  "VENUE_ID",
  "CITY_NAME",
  "MAIN_VIDEO",
  "STAKE",
  "BRANDED_INSIGHT"
];
var dataPoints2 = [
  { name: "DAY", type: "TEXT", autoImportName: "DAY" },
  { name: "DATE", type: "TEXT", autoImportName: "DATE" },
  { name: "MONTH", type: "TEXT", autoImportName: "MONTH" },
  { name: "TIME", type: "TEXT", autoImportName: "TIME" },
  { name: "COUNTDOWN", type: "TEXT", autoImportName: "COUNTDOWN" },
  { name: "SPORT_NAME", type: "TEXT", autoImportName: "SPORT_NAME" },
  {
    name: "COMPETITION_NAME",
    type: "TEXT",
    autoImportName: "COMPETITION_NAME"
  },
  { name: "EVENT_NAME", type: "TEXT", autoImportName: "EVENT_NAME" },
  { name: "HOME_NAME", type: "TEXT", autoImportName: "HOME_NAME" },
  { name: "AWAY_NAME", type: "TEXT", autoImportName: "AWAY_NAME" },
  { name: "HOME_NAME_MICRO", type: "TEXT", autoImportName: "HOME_NAME_MICRO" },
  { name: "AWAY_NAME_MICRO", type: "TEXT", autoImportName: "AWAY_NAME_MICRO" },
  { name: "COMPETITOR_ID", type: "TEAM_ASSET" },
  { name: "HOME_COMPETITOR_ID", type: "IMAGE", autoImportName: "HOME_CUSTOM" },
  { name: "AWAY_COMPETITOR_ID", type: "IMAGE", autoImportName: "AWAY_CUSTOM" },
  { name: "COMPETITION_ID", type: "IMAGE" },
  { name: "VENUE", type: "TEXT", autoImportName: "VENUE" },
  { name: "CITY_NAME", type: "TEXT", autoImportName: "CITY_NAME" },
  { name: "VENUE_ID", type: "IMAGE" },
  { name: "SPORT_ID", type: "IMAGE" },
  { name: "HOME_COMPETITOR_COUNTRY_CODE", type: "IMAGE" },
  { name: "AWAY_COMPETITOR_COUNTRY_CODE", type: "IMAGE" },
  { name: "MAIN_VIDEO", type: "IMAGE" },
  { name: "STAKE", type: "TEXT", autoImportName: "STAKE" },
  {
    name: "BRANDED_INSIGHT",
    type: "TEXT",
    autoImportName: "BRANDED_INSIGHT"
  }
];

// src/Recommenders/NewEvent/index.ts
var typeName2 = "NEW_EVENT";
var dataPoints3 = [
  {
    name: "HOME_COLOR_PRIMARY",
    autoImportName: "HOME_COLOR_PRIMARY",
    type: "VECTOR"
  },
  {
    name: "HOME_COLOR_SECONDARY",
    autoImportName: "HOME_COLOR_SECONDARY",
    type: "VECTOR"
  },
  {
    name: "AWAY_COLOR_PRIMARY",
    autoImportName: "AWAY_COLOR_PRIMARY",
    type: "VECTOR"
  },
  {
    name: "AWAY_COLOR_SECONDARY",
    autoImportName: "AWAY_COLOR_SECONDARY",
    type: "VECTOR"
  }
];
var dataSourceConfig2 = {
  name: "Event",
  points: [...dataPoints3, ...dataPoints2],
  dataType: "TEMPLATE",
  type: "NEW_EVENT"
};
var dataPointNames3 = [
  "HOME_COLOR_PRIMARY",
  "HOME_COLOR_SECONDARY",
  "AWAY_COLOR_PRIMARY",
  "AWAY_COLOR_SECONDARY"
];

// src/Recommenders/Outright/index.ts
var typeName3 = "OUTRIGHT";
var dataPointNames4 = ["SPORT_NAME", "COMPETITION_NAME", "OUTRIGHT_NAME"];
var dataPoints4 = [
  { name: "SPORT_NAME", type: "TEXT", autoImportName: "SPORT_NAME-OR" },
  {
    name: "COMPETITION_NAME",
    type: "TEXT",
    autoImportName: "COMPETITION_NAME-OR"
  },
  { name: "OUTRIGHT_NAME", type: "TEXT", autoImportName: "OUTRIGHT_NAME-OR" }
];
var dataSourceConfig3 = {
  name: "Outright",
  points: dataPoints4,
  dataType: "TEMPLATE",
  type: typeName3
};

// src/Recommenders/EventCompetitorFocused/index.ts
var typeName4 = "EVENT_COMPETITOR_FOCUSED";
var dataPointNames5 = [
  "COMPETITOR_NAME",
  "OPPONENT_NAME",
  "COMPETITOR_MICRO_NAME",
  "OPPONENT_MICRO_NAME",
  "FOCUS_COMPETITOR_ID",
  "OPPONENT_COMPETITOR_ID",
  "FOCUS_COMPETITOR_COUNTRY_CODE",
  "OPPONENT_COMPETITOR_COUNTRY_CODE"
];
var cfPoints = [
  ...dataPointNames5,
  ...[
    "OPPONENT_ODDS-",
    "COMPETITOR_ODDS-",
    "OPPONENT_JERSEY",
    "COMPETITOR_JERSEY",
    "OPPONENT_BADGE",
    "COMPETITOR_BADGE"
  ]
  // these are used by markets
];
var dataPoints5 = [
  {
    name: "COMPETITOR_NAME",
    autoImportName: "COMPETITOR_NAME",
    type: "TEXT"
  },
  { name: "OPPONENT_NAME", autoImportName: "OPPONENT_NAME", type: "TEXT" },
  {
    name: "COMPETITOR_MICRO_NAME",
    autoImportName: "COMPETITOR_MICRO_NAME",
    type: "TEXT"
  },
  {
    name: "OPPONENT_MICRO_NAME",
    autoImportName: "OPPONENT_MICRO_NAME",
    type: "TEXT"
  },
  {
    name: "FOCUS_COMPETITOR_ID",
    type: "IMAGE"
  },
  {
    name: "OPPONENT_COMPETITOR_ID",
    type: "IMAGE"
  },
  {
    name: "FOCUS_COMPETITOR_COUNTRY_CODE",
    type: "IMAGE"
  },
  {
    name: "OPPONENT_COMPETITOR_COUNTRY_CODE",
    type: "IMAGE"
  }
];
var isCompetitorFocusedPoint = (point) => {
  return cfPoints.some((cfPoint) => point.startsWith(cfPoint));
};
var isCompetitorFilter = (config, isCompetitorFocused) => !(isCompetitorFocused && config.dataType === "TEMPLATE" && config.type !== typeName4);
var dataSourceConfig4 = {
  name: "Event - Competitor Focused",
  points: [...dataPoints5, ...dataPoints2],
  dataType: "TEMPLATE",
  type: typeName4
};

// src/Recommenders/MatchWinner/index.ts
var MatchWinner_exports = {};
__export(MatchWinner_exports, {
  dataPointNames: () => dataPointNames6,
  dataPoints: () => dataPoints6,
  dataSourceConfig: () => dataSourceConfig5,
  typeName: () => typeName5
});
var typeName5 = "MATCH_WINNER";
var dataPointNames6 = [
  "MARKET_NAME",
  "HOME_ODDS",
  "HOME_PERCENT_BETS",
  "HOME_PERCENT_MONEY",
  "AWAY_ODDS",
  "AWAY_PERCENT_BETS",
  "AWAY_PERCENT_MONEY",
  "COMPETITOR_ODDS",
  "OPPONENT_ODDS",
  "INSIGHT_TEXT"
];
var dataPoints6 = [
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-MW" },
  { name: "HOME_ODDS", type: "TEXT", autoImportName: "HOME_ODDS-MW" },
  { name: "HOME_PERCENT_BETS", type: "TEXT", autoImportName: "HOME_PERCENT_BETS-MW" },
  { name: "HOME_PERCENT_MONEY", type: "TEXT", autoImportName: "HOME_PERCENT_MONEY-MW" },
  { name: "AWAY_ODDS", type: "TEXT", autoImportName: "AWAY_ODDS-MW" },
  { name: "AWAY_PERCENT_BETS", type: "TEXT", autoImportName: "AWAY_PERCENT_BETS-MW" },
  { name: "AWAY_PERCENT_MONEY", type: "TEXT", autoImportName: "AWAY_PERCENT_MONEY-MW" },
  {
    name: "COMPETITOR_ODDS",
    autoImportName: "COMPETITOR_ODDS-MW",
    type: "TEXT"
  },
  { name: "OPPONENT_ODDS", autoImportName: "OPPONENT_ODDS-MW", type: "TEXT" },
  { name: "INSIGHT_TEXT", autoImportName: "INSIGHT_TEXT-MW", type: "TEXT" }
];
var dataSourceConfig5 = {
  name: "Match Winner",
  points: dataPoints6,
  dataType: "MARKET",
  type: typeName5
};

// src/Recommenders/FullTimeResult/index.ts
var typeName6 = "FULL_TIME_RESULT";
var dataPointNames7 = [
  "MARKET_NAME",
  "HOME_ODDS",
  "HOME_PERCENT_BETS",
  "HOME_PERCENT_MONEY",
  "AWAY_ODDS",
  "AWAY_PERCENT_BETS",
  "AWAY_PERCENT_MONEY",
  "DRAW_ODDS",
  "DRAW_PERCENT_BETS",
  "DRAW_PERCENT_MONEY",
  "INSIGHT_TEXT"
];
var dataPoints7 = [
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-FTR" },
  { name: "HOME_ODDS", type: "TEXT", autoImportName: "HOME_ODDS-FTR" },
  { name: "HOME_PERCENT_BETS", type: "TEXT", autoImportName: "HOME_PERCENT_BETS-FTR" },
  { name: "HOME_PERCENT_MONEY", type: "TEXT", autoImportName: "HOME_PERCENT_MONEY-FTR" },
  { name: "AWAY_ODDS", type: "TEXT", autoImportName: "AWAY_ODDS-FTR" },
  { name: "AWAY_PERCENT_BETS", type: "TEXT", autoImportName: "AWAY_PERCENT_BETS-FTR" },
  { name: "AWAY_PERCENT_MONEY", type: "TEXT", autoImportName: "AWAY_PERCENT_MONEY-FTR" },
  { name: "DRAW_ODDS", type: "TEXT", autoImportName: "DRAW_ODDS-FTR" },
  { name: "DRAW_PERCENT_BETS", type: "TEXT", autoImportName: "DRAW_PERCENT_BETS-FTR" },
  { name: "DRAW_PERCENT_MONEY", type: "TEXT", autoImportName: "DRAW_PERCENT_MONEY-FTR" },
  {
    name: "COMPETITOR_ODDS",
    autoImportName: "COMPETITOR_ODDS-FTR",
    type: "TEXT"
  },
  { name: "OPPONENT_ODDS", autoImportName: "OPPONENT_ODDS-FTR", type: "TEXT" },
  { name: "INSIGHT_TEXT", type: "TEXT", autoImportName: "INSIGHT_TEXT-FTR" }
];
var dataSourceConfig6 = {
  name: "Full Time Result",
  points: dataPoints7,
  dataType: "MARKET",
  type: typeName6
};

// src/Recommenders/Promo/index.ts
var typeName7 = "PROMO";
var dataPointNames8 = [
  "MARKET_NAME",
  "PROMO_ODDS",
  "PROMO_WAS_ODDS",
  "PROMO_TEXT"
];
var dataPoints8 = [
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-PR" },
  { name: "PROMO_ODDS", type: "TEXT", autoImportName: "PROMO_ODDS-PR" },
  { name: "PROMO_WAS_ODDS", type: "TEXT", autoImportName: "PROMO_WAS_ODDS-PR" },
  { name: "PROMO_TEXT", type: "TEXT", autoImportName: "PROMO_TEXT-PR" }
];
var dataSourceConfig7 = {
  name: "Promo",
  points: dataPoints8,
  dataType: "MARKET",
  type: typeName7
};

// src/Recommenders/Handicap/index.ts
var typeName8 = "HANDICAP";
var dataPointNames9 = [
  "MARKET_NAME",
  "AWAY_ODDS",
  "AWAY_PERCENT_BETS",
  "AWAY_PERCENT_MONEY",
  "AWAY_SPREAD",
  "HOME_ODDS",
  "HOME_PERCENT_BETS",
  "HOME_PERCENT_MONEY",
  "HOME_SPREAD",
  "INSIGHT_TEXT"
];
var dataPoints9 = [
  { name: "MARKET_NAME", autoImportName: "MARKET_NAME-HC", type: "TEXT" },
  { name: "HOME_ODDS", autoImportName: "HOME_ODDS-HC", type: "TEXT" },
  { name: "HOME_PERCENT_BETS", autoImportName: "HOME_PERCENT_BETS-HC", type: "TEXT" },
  { name: "HOME_PERCENT_MONEY", autoImportName: "HOME_PERCENT_MONEY-HC", type: "TEXT" },
  { name: "HOME_SPREAD", autoImportName: "HOME_SPREAD-HC", type: "TEXT" },
  { name: "AWAY_ODDS", autoImportName: "AWAY_ODDS-HC", type: "TEXT" },
  { name: "AWAY_PERCENT_BETS", autoImportName: "AWAY_PERCENT_BETS-HC", type: "TEXT" },
  { name: "AWAY_PERCENT_MONEY", autoImportName: "AWAY_PERCENT_MONEY-HC", type: "TEXT" },
  { name: "AWAY_SPREAD", autoImportName: "AWAY_SPREAD-HC", type: "TEXT" },
  { name: "INSIGHT_TEXT", autoImportName: "INSIGHT_TEXT-HC", type: "TEXT" }
];
var dataSourceConfig8 = {
  name: "Handicap",
  points: dataPoints9,
  dataType: "MARKET",
  type: typeName8
};

// src/Recommenders/OverUnder/index.ts
var typeName9 = "OVER_UNDER";
var dataPointNames10 = [
  "MARKET_NAME",
  "OVER_ODDS",
  "UNDER_ODDS",
  "TOTAL",
  "INSIGHT_TEXT"
];
var dataPoints10 = [
  { name: "MARKET_NAME", autoImportName: "MARKET_NAME-OU", type: "TEXT" },
  { name: "OVER_ODDS", autoImportName: "OVER_ODDS-OU", type: "TEXT" },
  { name: "UNDER_ODDS", autoImportName: "UNDER_ODDS-OU", type: "TEXT" },
  { name: "TOTAL", autoImportName: "TOTAL-OU", type: "TEXT" },
  { name: "INSIGHT_TEXT", autoImportName: "INSIGHT_TEXT-OU", type: "TEXT" }
];
var dataSourceConfig9 = {
  name: "Over/Under",
  points: dataPoints10,
  dataType: "MARKET",
  type: typeName9
};

// src/Recommenders/CompetitionWinner/index.ts
var typeName10 = "COMPETITION_WINNER";
var dataPointNames11 = [
  "MARKET_NAME",
  "OPTION_1_NAME",
  "OPTION_1_ODDS",
  "OPTION_1_COMPETITOR_ID",
  "OPTION_2_NAME",
  "OPTION_2_ODDS",
  "OPTION_2_COMPETITOR_ID",
  "OPTION_3_NAME",
  "OPTION_3_ODDS",
  "OPTION_3_COMPETITOR_ID",
  "OPTION_4_NAME",
  "OPTION_4_ODDS",
  "OPTION_4_COMPETITOR_ID",
  "OPTION_5_NAME",
  "OPTION_5_ODDS",
  "OPTION_5_COMPETITOR_ID",
  "OPTION_6_NAME",
  "OPTION_6_ODDS",
  "OPTION_6_COMPETITOR_ID",
  "OPTION_7_NAME",
  "OPTION_7_ODDS",
  "OPTION_7_COMPETITOR_ID",
  "OPTION_8_NAME",
  "OPTION_8_ODDS",
  "OPTION_8_COMPETITOR_ID",
  "OPTION_9_NAME",
  "OPTION_9_ODDS",
  "OPTION_9_COMPETITOR_ID",
  "OPTION_10_NAME",
  "OPTION_10_ODDS",
  "OPTION_10_COMPETITOR_ID"
];
var dataPoints11 = [
  { name: "SPORT_ID", type: "IMAGE" },
  { name: "COMPETITION_ID", type: "IMAGE" },
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-CW" },
  { name: "OPTION_1_NAME", type: "TEXT", autoImportName: "OPTION_1_NAME-CW" },
  { name: "OPTION_1_ODDS", type: "TEXT", autoImportName: "OPTION_1_ODDS-CW" },
  { name: "OPTION_1_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_2_NAME", type: "TEXT", autoImportName: "OPTION_2_NAME-CW" },
  { name: "OPTION_2_ODDS", type: "TEXT", autoImportName: "OPTION_2_ODDS-CW" },
  { name: "OPTION_2_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_3_NAME", type: "TEXT", autoImportName: "OPTION_3_NAME-CW" },
  { name: "OPTION_3_ODDS", type: "TEXT", autoImportName: "OPTION_3_ODDS-CW" },
  { name: "OPTION_3_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_4_NAME", type: "TEXT", autoImportName: "OPTION_4_NAME-CW" },
  { name: "OPTION_4_ODDS", type: "TEXT", autoImportName: "OPTION_4_ODDS-CW" },
  { name: "OPTION_4_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_5_NAME", type: "TEXT", autoImportName: "OPTION_5_NAME-CW" },
  { name: "OPTION_5_ODDS", type: "TEXT", autoImportName: "OPTION_5_ODDS-CW" },
  { name: "OPTION_5_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_6_NAME", type: "TEXT", autoImportName: "OPTION_6_NAME-CW" },
  { name: "OPTION_6_ODDS", type: "TEXT", autoImportName: "OPTION_6_ODDS-CW" },
  { name: "OPTION_6_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_7_NAME", type: "TEXT", autoImportName: "OPTION_7_NAME-CW" },
  { name: "OPTION_7_ODDS", type: "TEXT", autoImportName: "OPTION_7_ODDS-CW" },
  { name: "OPTION_7_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_8_NAME", type: "TEXT", autoImportName: "OPTION_8_NAME-CW" },
  { name: "OPTION_8_ODDS", type: "TEXT", autoImportName: "OPTION_8_ODDS-CW" },
  { name: "OPTION_8_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_9_NAME", type: "TEXT", autoImportName: "OPTION_9_NAME-CW" },
  { name: "OPTION_9_ODDS", type: "TEXT", autoImportName: "OPTION_9_ODDS-CW" },
  { name: "OPTION_9_COMPETITOR_ID", type: "IMAGE" },
  { name: "OPTION_10_NAME", type: "TEXT", autoImportName: "OPTION_10_NAME-CW" },
  { name: "OPTION_10_ODDS", type: "TEXT", autoImportName: "OPTION_10_ODDS-CW" },
  { name: "OPTION_10_COMPETITOR_ID", type: "IMAGE" }
];
var dataSourceConfig10 = {
  name: "Competition Winner",
  points: dataPoints11,
  dataType: "MARKET",
  type: typeName10
};

// src/Recommenders/SameGameParlay/index.ts
var typeName11 = "SAME_GAME_PARLAY";
var dataPointNames12 = [
  "MARKET_NAME",
  "ODDS",
  "WAS_ODDS",
  "OPTION_1_NAME",
  "OPTION_1_OUTCOME_NAME",
  "OPTION_1_MARKET_NAME",
  "OPTION_2_NAME",
  "OPTION_2_OUTCOME_NAME",
  "OPTION_2_MARKET_NAME",
  "OPTION_3_NAME",
  "OPTION_3_OUTCOME_NAME",
  "OPTION_3_MARKET_NAME",
  "OPTION_4_NAME",
  "OPTION_4_OUTCOME_NAME",
  "OPTION_4_MARKET_NAME",
  "OPTION_5_NAME",
  "OPTION_5_OUTCOME_NAME",
  "OPTION_5_MARKET_NAME"
];
var dataPoints12 = [
  {
    name: "MARKET_NAME",
    type: "TEXT",
    autoImportName: "MARKET_NAME-SGP"
  },
  {
    name: "ODDS",
    type: "TEXT",
    autoImportName: "ODDS-SGP"
  },
  {
    name: "WAS_ODDS",
    type: "TEXT",
    autoImportName: "WAS_ODDS-SGP"
  },
  {
    name: "OPTION_1_NAME",
    type: "TEXT",
    autoImportName: "OPTION_1_NAME-SGP"
  },
  {
    name: "OPTION_1_OUTCOME_NAME",
    type: "TEXT",
    autoImportName: "OPTION_1_OUTCOME_NAME-SGP"
  },
  {
    name: "OPTION_1_MARKET_NAME",
    type: "TEXT",
    autoImportName: "OPTION_1_MARKET_NAME-SGP"
  },
  {
    name: "OPTION_2_NAME",
    type: "TEXT",
    autoImportName: "OPTION_2_NAME-SGP"
  },
  {
    name: "OPTION_2_OUTCOME_NAME",
    type: "TEXT",
    autoImportName: "OPTION_2_OUTCOME_NAME-SGP"
  },
  {
    name: "OPTION_2_MARKET_NAME",
    type: "TEXT",
    autoImportName: "OPTION_2_MARKET_NAME-SGP"
  },
  {
    name: "OPTION_3_NAME",
    type: "TEXT",
    autoImportName: "OPTION_3_NAME-SGP"
  },
  {
    name: "OPTION_3_OUTCOME_NAME",
    type: "TEXT",
    autoImportName: "OPTION_3_OUTCOME_NAME-SGP"
  },
  {
    name: "OPTION_3_MARKET_NAME",
    type: "TEXT",
    autoImportName: "OPTION_3_MARKET_NAME-SGP"
  },
  {
    name: "OPTION_4_NAME",
    type: "TEXT",
    autoImportName: "OPTION_4_NAME-SGP"
  },
  {
    name: "OPTION_4_OUTCOME_NAME",
    type: "TEXT",
    autoImportName: "OPTION_4_OUTCOME_NAME-SGP"
  },
  {
    name: "OPTION_4_MARKET_NAME",
    type: "TEXT",
    autoImportName: "OPTION_4_MARKET_NAME-SGP"
  },
  {
    name: "OPTION_5_NAME",
    type: "TEXT",
    autoImportName: "OPTION_5_NAME-SGP"
  },
  {
    name: "OPTION_5_OUTCOME_NAME",
    type: "TEXT",
    autoImportName: "OPTION_5_OUTCOME_NAME-SGP"
  },
  {
    name: "OPTION_5_MARKET_NAME",
    type: "TEXT",
    autoImportName: "OPTION_5_MARKET_NAME-SGP"
  }
];
var dataSourceConfig11 = {
  name: "Same Game Parlay",
  points: dataPoints12,
  dataType: "MARKET",
  type: typeName11
};

// src/Recommenders/PlayerProps/index.ts
var typeName12 = "PLAYER_PROPS";
var dataPointNames13 = [
  "MARKET_NAME",
  "HOME_POINTS_NAME",
  "HOME_POINTS_TOTAL",
  "HOME_POINTS_NAME_2",
  "HOME_POINTS_TOTAL_2",
  "HOME_POINTS_NAME_3",
  "HOME_POINTS_TOTAL_3",
  "HOME_POINTS_NAME_4",
  "HOME_POINTS_TOTAL_4",
  "HOME_POINTS_NAME_5",
  "HOME_POINTS_TOTAL_5",
  "AWAY_POINTS_NAME",
  "AWAY_POINTS_TOTAL",
  "AWAY_POINTS_NAME_2",
  "AWAY_POINTS_TOTAL_2",
  "AWAY_POINTS_NAME_3",
  "AWAY_POINTS_TOTAL_3",
  "AWAY_POINTS_NAME_4",
  "AWAY_POINTS_TOTAL_4",
  "AWAY_POINTS_NAME_5",
  "AWAY_POINTS_TOTAL_5",
  "TOP_POINTS_NAME",
  "TOP_POINTS_TOTAL",
  "TOP_REBOUNDS_NAME",
  "TOP_REBOUNDS_TOTAL",
  "TOP_ASSISTS_NAME",
  "TOP_ASSISTS_TOTAL",
  "TOP_POINTS_COMPETITOR_ID",
  "TOP_REBOUNDS_COMPETITOR_ID",
  "TOP_ASSISTS_COMPETITOR_ID",
  "HOME_PITCHER_STRIKEOUTS_NAME",
  "HOME_PITCHER_STRIKEOUTS_TOTAL",
  "AWAY_PITCHER_STRIKEOUTS_NAME",
  "AWAY_PITCHER_STRIKEOUTS_TOTAL",
  "HOME_HITS_NAME",
  "HOME_HITS_TOTAL",
  "HOME_HITS_NAME_2",
  "HOME_HITS_TOTAL_2",
  "HOME_HITS_NAME_3",
  "HOME_HITS_TOTAL_3",
  "HOME_HITS_NAME_4",
  "HOME_HITS_TOTAL_4",
  "HOME_HITS_NAME_5",
  "HOME_HITS_TOTAL_5",
  "AWAY_HITS_NAME",
  "AWAY_HITS_TOTAL",
  "AWAY_HITS_NAME_2",
  "AWAY_HITS_TOTAL_2",
  "AWAY_HITS_NAME_3",
  "AWAY_HITS_TOTAL_3",
  "AWAY_HITS_NAME_4",
  "AWAY_HITS_TOTAL_4",
  "AWAY_HITS_NAME_5",
  "AWAY_HITS_TOTAL_5",
  "HOME_PASSING_YARDS_NAME",
  "HOME_PASSING_YARDS_TOTAL",
  "AWAY_PASSING_YARDS_NAME",
  "AWAY_PASSING_YARDS_TOTAL",
  "HOME_RUSHING_YARDS_NAME",
  "HOME_RUSHING_YARDS_TOTAL",
  "AWAY_RUSHING_YARDS_NAME",
  "AWAY_RUSHING_YARDS_TOTAL",
  "HOME_RECEIVING_YARDS_NAME",
  "HOME_RECEIVING_YARDS_TOTAL",
  "AWAY_RECEIVING_YARDS_NAME",
  "AWAY_RECEIVING_YARDS_TOTAL"
];
var dataPoints13 = [
  { name: "MARKET_NAME", autoImportName: "MARKET_NAME-PP", type: "TEXT" },
  { name: "HOME_POINTS_NAME", autoImportName: "HOME_POINTS_NAME-PP", type: "TEXT" },
  { name: "HOME_POINTS_TOTAL", autoImportName: "HOME_POINTS_TOTAL-PP", type: "TEXT" },
  { name: "HOME_POINTS_NAME_2", autoImportName: "HOME_POINTS_NAME_2-PP", type: "TEXT" },
  { name: "HOME_POINTS_TOTAL_2", autoImportName: "HOME_POINTS_TOTAL_2-PP", type: "TEXT" },
  { name: "HOME_POINTS_NAME_3", autoImportName: "HOME_POINTS_NAME_3-PP", type: "TEXT" },
  { name: "HOME_POINTS_TOTAL_3", autoImportName: "HOME_POINTS_TOTAL_3-PP", type: "TEXT" },
  { name: "HOME_POINTS_NAME_4", autoImportName: "HOME_POINTS_NAME_4-PP", type: "TEXT" },
  { name: "HOME_POINTS_TOTAL_4", autoImportName: "HOME_POINTS_TOTAL_4-PP", type: "TEXT" },
  { name: "HOME_POINTS_NAME_5", autoImportName: "HOME_POINTS_NAME_5-PP", type: "TEXT" },
  { name: "HOME_POINTS_TOTAL_5", autoImportName: "HOME_POINTS_TOTAL_5-PP", type: "TEXT" },
  { name: "AWAY_POINTS_NAME", autoImportName: "AWAY_POINTS_NAME-PP", type: "TEXT" },
  { name: "AWAY_POINTS_TOTAL", autoImportName: "AWAY_POINTS_TOTAL-PP", type: "TEXT" },
  { name: "AWAY_POINTS_NAME_2", autoImportName: "AWAY_POINTS_NAME_2-PP", type: "TEXT" },
  { name: "AWAY_POINTS_TOTAL_2", autoImportName: "AWAY_POINTS_TOTAL_2-PP", type: "TEXT" },
  { name: "AWAY_POINTS_NAME_3", autoImportName: "AWAY_POINTS_NAME_3-PP", type: "TEXT" },
  { name: "AWAY_POINTS_TOTAL_3", autoImportName: "AWAY_POINTS_TOTAL_3-PP", type: "TEXT" },
  { name: "AWAY_POINTS_NAME_4", autoImportName: "AWAY_POINTS_NAME_4-PP", type: "TEXT" },
  { name: "AWAY_POINTS_TOTAL_4", autoImportName: "AWAY_POINTS_TOTAL_4-PP", type: "TEXT" },
  { name: "AWAY_POINTS_NAME_5", autoImportName: "AWAY_POINTS_NAME_5-PP", type: "TEXT" },
  { name: "AWAY_POINTS_TOTAL_5", autoImportName: "AWAY_POINTS_TOTAL_5-PP", type: "TEXT" },
  { name: "TOP_POINTS_NAME", autoImportName: "TOP_POINTS_NAME-PP", type: "TEXT" },
  { name: "TOP_POINTS_TOTAL", autoImportName: "TOP_POINTS_TOTAL-PP", type: "TEXT" },
  { name: "TOP_REBOUNDS_NAME", autoImportName: "TOP_REBOUNDS_NAME-PP", type: "TEXT" },
  { name: "TOP_REBOUNDS_TOTAL", autoImportName: "TOP_REBOUNDS_TOTAL-PP", type: "TEXT" },
  { name: "TOP_ASSISTS_NAME", autoImportName: "TOP_ASSISTS_NAME-PP", type: "TEXT" },
  { name: "TOP_ASSISTS_TOTAL", autoImportName: "TOP_ASSISTS_TOTAL-PP", type: "TEXT" },
  { name: "TOP_POINTS_COMPETITOR_ID", type: "IMAGE" },
  { name: "TOP_REBOUNDS_COMPETITOR_ID", type: "IMAGE" },
  { name: "TOP_ASSISTS_COMPETITOR_ID", type: "IMAGE" },
  {
    name: "HOME_PITCHER_STRIKEOUTS_NAME",
    autoImportName: "HOME_PITCHER_STRIKEOUTS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "HOME_PITCHER_STRIKEOUTS_TOTAL",
    autoImportName: "HOME_PITCHER_STRIKEOUTS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_PITCHER_STRIKEOUTS_NAME",
    autoImportName: "AWAY_PITCHER_STRIKEOUTS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_PITCHER_STRIKEOUTS_TOTAL",
    autoImportName: "AWAY_PITCHER_STRIKEOUTS_TOTAL-PP",
    type: "TEXT"
  },
  { name: "HOME_HITS_NAME", autoImportName: "HOME_HITS_NAME-PP", type: "TEXT" },
  { name: "HOME_HITS_TOTAL", autoImportName: "HOME_HITS_TOTAL-PP", type: "TEXT" },
  { name: "AWAY_HITS_NAME", autoImportName: "AWAY_HITS_NAME-PP", type: "TEXT" },
  { name: "AWAY_HITS_TOTAL", autoImportName: "AWAY_HITS_TOTAL-PP", type: "TEXT" },
  { name: "HOME_HITS_NAME_2", autoImportName: "HOME_HITS_NAME_2-PP", type: "TEXT" },
  { name: "HOME_HITS_TOTAL_2", autoImportName: "HOME_HITS_TOTAL_2-PP", type: "TEXT" },
  { name: "HOME_HITS_NAME_3", autoImportName: "HOME_HITS_NAME_3-PP", type: "TEXT" },
  { name: "HOME_HITS_TOTAL_3", autoImportName: "HOME_HITS_TOTAL_3-PP", type: "TEXT" },
  { name: "HOME_HITS_NAME_4", autoImportName: "HOME_HITS_NAME_4-PP", type: "TEXT" },
  { name: "HOME_HITS_TOTAL_4", autoImportName: "HOME_HITS_TOTAL_4-PP", type: "TEXT" },
  { name: "HOME_HITS_NAME_5", autoImportName: "HOME_HITS_NAME_5-PP", type: "TEXT" },
  { name: "HOME_HITS_TOTAL_5", autoImportName: "HOME_HITS_TOTAL_5-PP", type: "TEXT" },
  { name: "AWAY_HITS_NAME_2", autoImportName: "AWAY_HITS_NAME_2-PP", type: "TEXT" },
  { name: "AWAY_HITS_TOTAL_2", autoImportName: "AWAY_HITS_TOTAL_2-PP", type: "TEXT" },
  { name: "AWAY_HITS_NAME_3", autoImportName: "AWAY_HITS_NAME_3-PP", type: "TEXT" },
  { name: "AWAY_HITS_TOTAL_3", autoImportName: "AWAY_HITS_TOTAL_3-PP", type: "TEXT" },
  { name: "AWAY_HITS_NAME_4", autoImportName: "AWAY_HITS_NAME_4-PP", type: "TEXT" },
  { name: "AWAY_HITS_TOTAL_4", autoImportName: "AWAY_HITS_TOTAL_4-PP", type: "TEXT" },
  { name: "AWAY_HITS_NAME_5", autoImportName: "AWAY_HITS_NAME_5-PP", type: "TEXT" },
  { name: "AWAY_HITS_TOTAL_5", autoImportName: "AWAY_HITS_TOTAL_5-PP", type: "TEXT" },
  {
    name: "HOME_PASSING_YARDS_NAME",
    autoImportName: "HOME_PASSING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "HOME_PASSING_YARDS_TOTAL",
    autoImportName: "HOME_PASSING_YARDS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_PASSING_YARDS_NAME",
    autoImportName: "AWAY_PASSING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_PASSING_YARDS_TOTAL",
    autoImportName: "AWAY_PASSING_YARDS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "HOME_RUSHING_YARDS_NAME",
    autoImportName: "HOME_RUSHING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "HOME_RUSHING_YARDS_TOTAL",
    autoImportName: "HOME_RUSHING_YARDS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_RUSHING_YARDS_NAME",
    autoImportName: "AWAY_RUSHING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_RUSHING_YARDS_TOTAL",
    autoImportName: "AWAY_RUSHING_YARDS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "HOME_RECEIVING_YARDS_NAME",
    autoImportName: "HOME_RECEIVING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "HOME_RECEIVING_YARDS_TOTAL",
    autoImportName: "HOME_RECEIVING_YARDS_TOTAL-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_RECEIVING_YARDS_NAME",
    autoImportName: "AWAY_RECEIVING_YARDS_NAME-PP",
    type: "TEXT"
  },
  {
    name: "AWAY_RECEIVING_YARDS_TOTAL",
    autoImportName: "AWAY_RECEIVING_YARDS_TOTAL-PP",
    type: "TEXT"
  }
];
var dataSourceConfig12 = {
  name: "Player Props",
  points: dataPoints13,
  dataType: "MARKET",
  type: typeName12
};

// src/Recommenders/OddsComparison/index.ts
var typeName13 = "ODDS_COMPARISON";
var dataPointNames14 = [
  "MARKET_NAME",
  "OPTION_NAME",
  "OPTION_NAME_ABBR",
  "OPERATOR_ODDS",
  "COMPARISON_1_NAME",
  "COMPARISON_1_ODDS",
  "COMPARISON_2_NAME",
  "COMPARISON_2_ODDS",
  "COMPARISON_3_NAME",
  "COMPARISON_3_ODDS"
];
var dataPoints14 = [
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-OC" },
  { name: "OPTION_NAME", type: "TEXT", autoImportName: "OPTION_NAME-OC" },
  { name: "OPTION_NAME_ABBR", type: "TEXT", autoImportName: "OPTION_NAME_ABBR-OC" },
  { name: "OPERATOR_ODDS", type: "TEXT", autoImportName: "OPERATOR_ODDS-OC" },
  { name: "COMPARISON_1_NAME", type: "TEXT", autoImportName: "COMPARISON_1_NAME-OC" },
  { name: "COMPARISON_1_ODDS", type: "TEXT", autoImportName: "COMPARISON_1_ODDS-OC" },
  { name: "COMPARISON_2_NAME", type: "TEXT", autoImportName: "COMPARISON_2_NAME-OC" },
  { name: "COMPARISON_2_ODDS", type: "TEXT", autoImportName: "COMPARISON_2_ODDS-OC" },
  { name: "COMPARISON_3_NAME", type: "TEXT", autoImportName: "COMPARISON_3_NAME-OC" },
  { name: "COMPARISON_3_ODDS", type: "TEXT", autoImportName: "COMPARISON_3_ODDS-OC" }
];
var dataSourceConfig13 = {
  name: "Odds Comparison",
  points: dataPoints14,
  dataType: "MARKET",
  type: typeName13
};

// src/Recommenders/FirstGoalscorer/index.ts
var typeName14 = "FIRST_GOALSCORER";
var dataPointNames15 = [
  "MARKET_NAME",
  "OPTION_1_NAME",
  "OPTION_1_ODDS",
  "OPTION_2_NAME",
  "OPTION_2_ODDS",
  "OPTION_3_NAME",
  "OPTION_3_ODDS",
  "OPTION_4_NAME",
  "OPTION_4_ODDS",
  "OPTION_5_NAME",
  "OPTION_5_ODDS"
];
var dataPoints15 = [
  { name: "MARKET_NAME", type: "TEXT", autoImportName: "MARKET_NAME-FG" },
  { name: "OPTION_1_NAME", type: "TEXT", autoImportName: "OPTION_1_NAME-FG" },
  { name: "OPTION_1_ODDS", type: "TEXT", autoImportName: "OPTION_1_ODDS-FG" },
  { name: "OPTION_2_NAME", type: "TEXT", autoImportName: "OPTION_2_NAME-FG" },
  { name: "OPTION_2_ODDS", type: "TEXT", autoImportName: "OPTION_2_ODDS-FG" },
  { name: "OPTION_3_NAME", type: "TEXT", autoImportName: "OPTION_3_NAME-FG" },
  { name: "OPTION_3_ODDS", type: "TEXT", autoImportName: "OPTION_3_ODDS-FG" },
  { name: "OPTION_4_NAME", type: "TEXT", autoImportName: "OPTION_4_NAME-FG" },
  { name: "OPTION_4_ODDS", type: "TEXT", autoImportName: "OPTION_4_ODDS-FG" },
  { name: "OPTION_5_NAME", type: "TEXT", autoImportName: "OPTION_5_NAME-FG" },
  { name: "OPTION_5_ODDS", type: "TEXT", autoImportName: "OPTION_5_ODDS-FG" }
];
var dataSourceConfig14 = {
  name: "First Goalscorer",
  points: dataPoints15,
  dataType: "MARKET",
  type: typeName14
};

// src/Recommenders/Datasources.ts
var sourceTypes = [
  typeName,
  "UNKNOWN_FUTURE_ADDITION",
  typeName2,
  typeName4,
  typeName3,
  typeName5,
  typeName6,
  typeName7,
  typeName9,
  typeName8,
  typeName10,
  typeName11,
  typeName12,
  typeName13,
  typeName14
];
var combinedDP = [
  ...dataPointNames3,
  ...dataPointNames5,
  ...dataPointNames2,
  ...dataPointNames6,
  ...dataPointNames7,
  ...dataPointNames8,
  ...dataPointNames10,
  ...dataPointNames9,
  ...dataPointNames,
  ...dataPointNames4,
  ...dataPointNames11,
  ...dataPointNames12,
  ...dataPointNames13,
  ...dataPointNames14,
  ...dataPointNames15
];
var recommendersTypeMap = {
  [typeName5]: "MW",
  [typeName6]: "FTR",
  [typeName7]: "PR",
  [typeName9]: "OU",
  [typeName8]: "HC",
  [typeName4]: "",
  [typeName10]: "CW",
  [typeName11]: "SGP",
  [typeName3]: "OR",
  [typeName2]: "",
  [typeName]: "",
  [typeName12]: "PP",
  [typeName13]: "OC",
  [typeName14]: "FG",
  UNKNOWN_FUTURE_ADDITION: ""
};
var recommendersMarketDataTypes = [
  typeName5,
  typeName6,
  typeName7,
  typeName9,
  typeName8,
  typeName10,
  typeName11,
  typeName12,
  typeName13,
  typeName14
];
var normalisedMarketNames = {
  [typeName5]: "Match Winner",
  [typeName6]: "Full-Time Result",
  [typeName7]: "Promo",
  [typeName9]: "Over/Under Totals",
  [typeName8]: "Handicap Betting",
  [typeName10]: "Competition Winner",
  [typeName11]: "Same Game Parlay",
  [typeName12]: "Player Props",
  [typeName13]: "Odds Comparison",
  [typeName14]: "First Goalscorer"
};
var recommendersDataSourcesConfigs = [
  dataSourceConfig,
  dataSourceConfig2,
  dataSourceConfig4,
  dataSourceConfig3,
  dataSourceConfig5,
  dataSourceConfig6,
  dataSourceConfig7,
  dataSourceConfig8,
  dataSourceConfig9,
  dataSourceConfig10,
  dataSourceConfig11,
  dataSourceConfig12,
  dataSourceConfig13,
  dataSourceConfig14
];
var teamImagesMappingConfigs = [
  {
    name: "HOME_BADGE",
    autoImportName: "HOME_BADGE",
    dataType: "TEMPLATE",
    type: typeName2
  },
  {
    name: "HOME_JERSEY",
    autoImportName: "HOME_JERSEY",
    dataType: "TEMPLATE",
    type: typeName2
  },
  {
    name: "AWAY_BADGE",
    autoImportName: "AWAY_BADGE",
    dataType: "TEMPLATE",
    type: typeName2
  },
  {
    name: "AWAY_JERSEY",
    autoImportName: "AWAY_JERSEY",
    dataType: "TEMPLATE",
    type: typeName2
  },
  {
    name: "COMPETITOR_BADGE",
    autoImportName: "COMPETITOR_BADGE",
    dataType: "TEMPLATE",
    type: typeName4
  },
  {
    name: "COMPETITOR_JERSEY",
    autoImportName: "COMPETITOR_JERSEY",
    dataType: "TEMPLATE",
    type: typeName4
  },
  {
    name: "OPPONENT_BADGE",
    autoImportName: "OPPONENT_BADGE",
    dataType: "TEMPLATE",
    type: typeName4
  },
  {
    name: "OPPONENT_JERSEY",
    autoImportName: "OPPONENT_JERSEY",
    dataType: "TEMPLATE",
    type: typeName4
  }
];
var mapDataTypesFromSourceTypes = {
  [typeName]: "TEMPLATE",
  [typeName2]: "TEMPLATE",
  [typeName4]: "TEMPLATE",
  [typeName5]: "MARKET",
  [typeName6]: "MARKET",
  [typeName7]: "MARKET",
  [typeName9]: "MARKET",
  [typeName8]: "MARKET",
  [typeName3]: "TEMPLATE",
  [typeName10]: "MARKET",
  [typeName11]: "MARKET",
  [typeName12]: "MARKET",
  [typeName13]: "MARKET",
  [typeName14]: "MARKET",
  UNKNOWN_FUTURE_ADDITION: "UNKNOWN"
};
var recommendersFriendlyNameFromSourceTypeMap = {
  [typeName]: "Event",
  [typeName2]: "Event",
  [typeName3]: "Outright",
  [typeName4]: "Event - Competitor Focused",
  [typeName5]: "Match Winner",
  [typeName6]: "Full Time Result",
  [typeName7]: "Promo",
  [typeName9]: "Over/Under",
  [typeName8]: "Handicap",
  [typeName10]: "Competition Winner",
  [typeName11]: "Same Game Parlay",
  [typeName12]: "Player Props",
  [typeName13]: "Odds Comparison",
  [typeName14]: "First Goalscorer",
  UNKNOWN_FUTURE_ADDITION: "Unknown Future Addition"
};
var recommendersIconMap = {
  [typeName]: "LuCalendarClock",
  [typeName5]: "LuTarget",
  UNKNOWN_FUTURE_ADDITION: "LuXCircle",
  [typeName6]: "LuTimer",
  [typeName7]: "LuPercent",
  [typeName2]: "LuCalendarClock",
  [typeName9]: "LuTarget",
  [typeName8]: "LuTarget",
  [typeName3]: "LuTarget",
  [typeName10]: "LuTarget",
  [typeName11]: "LuTarget",
  [typeName4]: "LuDribbble",
  [typeName12]: "LuTarget",
  [typeName13]: "LuTarget",
  [typeName14]: "LuTarget"
};
var dataSourcesConfigs = recommendersDataSourcesConfigs;

// src/Direct/CarRacing/Nascar/Countdown/index.ts
var typeName15 = "NASCAR_COUNTDOWN";
var dataPointNames16 = ["COUNTDOWN", "RACE_NAME"];
var dataPoints16 = [
  { name: "COUNTDOWN", type: "TEXT", autoImportName: "COUNTDOWN" },
  { name: "RACE_NAME", type: "TEXT", autoImportName: "RACE_NAME" }
];
var nascarCountdownDataSourceConfig = {
  name: "Countdown",
  points: dataPoints16,
  dataType: "MARKET",
  type: typeName15
};

// src/Direct/CarRacing/Nascar/sharedDataPoints.ts
var nascarOptionDataPointNames = [
  "OPTION_1_NAME",
  "OPTION_1_GRID_POSITION",
  "OPTION_1_DRIVER_NUMBER",
  "OPTION_2_NAME",
  "OPTION_2_GRID_POSITION",
  "OPTION_2_DRIVER_NUMBER",
  "OPTION_3_NAME",
  "OPTION_3_GRID_POSITION",
  "OPTION_3_DRIVER_NUMBER",
  "OPTION_4_NAME",
  "OPTION_4_GRID_POSITION",
  "OPTION_4_DRIVER_NUMBER",
  "OPTION_5_NAME",
  "OPTION_5_GRID_POSITION",
  "OPTION_5_DRIVER_NUMBER"
];
var nascarOptionDataPoints = [
  { name: "OPTION_1_NAME", type: "TEXT", autoImportName: "OPTION_1_NAME" },
  {
    name: "OPTION_1_GRID_POSITION",
    type: "TEXT",
    autoImportName: "OPTION_1_GRID_POSITION"
  },
  {
    name: "OPTION_1_DRIVER_NUMBER",
    type: "TEXT",
    autoImportName: "OPTION_1_DRIVER_NUMBER"
  },
  { name: "OPTION_2_NAME", type: "TEXT", autoImportName: "OPTION_2_NAME" },
  {
    name: "OPTION_2_GRID_POSITION",
    type: "TEXT",
    autoImportName: "OPTION_2_GRID_POSITION"
  },
  {
    name: "OPTION_2_DRIVER_NUMBER",
    type: "TEXT",
    autoImportName: "OPTION_2_DRIVER_NUMBER"
  },
  { name: "OPTION_3_NAME", type: "TEXT", autoImportName: "OPTION_3_NAME" },
  {
    name: "OPTION_3_GRID_POSITION",
    type: "TEXT",
    autoImportName: "OPTION_3_GRID_POSITION"
  },
  {
    name: "OPTION_3_DRIVER_NUMBER",
    type: "TEXT",
    autoImportName: "OPTION_3_DRIVER_NUMBER"
  },
  { name: "OPTION_4_NAME", type: "TEXT", autoImportName: "OPTION_4_NAME" },
  {
    name: "OPTION_4_GRID_POSITION",
    type: "TEXT",
    autoImportName: "OPTION_4_GRID_POSITION"
  },
  {
    name: "OPTION_4_DRIVER_NUMBER",
    type: "TEXT",
    autoImportName: "OPTION_4_DRIVER_NUMBER"
  },
  { name: "OPTION_5_NAME", type: "TEXT", autoImportName: "OPTION_5_NAME" },
  {
    name: "OPTION_5_GRID_POSITION",
    type: "TEXT",
    autoImportName: "OPTION_5_GRID_POSITION"
  },
  {
    name: "OPTION_5_DRIVER_NUMBER",
    type: "TEXT",
    autoImportName: "OPTION_5_DRIVER_NUMBER"
  }
];
var nascarMomentDriverDataPointNames = [
  "MOMENT_DRIVER_NAME",
  "MOMENT_DRIVER_NUMBER",
  "MOMENT_DRIVER_CUSTOM",
  "MOMENT_CAR_TEAM_NAME"
];
var nascarMomentDriverDataPoints = [
  { name: "MOMENT_DRIVER_NAME", type: "TEXT", autoImportName: "MOMENT_DRIVER_NAME" },
  { name: "MOMENT_DRIVER_NUMBER", type: "TEXT", autoImportName: "MOMENT_DRIVER_NUMBER" },
  {
    name: "MOMENT_DRIVER_CUSTOM",
    type: "IMAGE",
    autoImportName: ["MOMENT_DRIVER_CUSTOM", "DRIVER_CUSTOM"]
  },
  { name: "MOMENT_CAR_TEAM_NAME", type: "TEXT", autoImportName: "MOMENT_CAR_TEAM_NAME" }
];

// src/Direct/CarRacing/Nascar/Live/index.ts
var typeName16 = "NASCAR_LIVE";
var dataPointNames17 = [...nascarOptionDataPointNames];
var dataPoints17 = nascarOptionDataPoints;
var nascarLiveDataSourceConfig = {
  name: "Live",
  points: dataPoints17,
  dataType: "MARKET",
  type: typeName16
};

// src/Direct/CarRacing/Nascar/Post/index.ts
var typeName17 = "NASCAR_POST";
var dataPointNames18 = [...nascarOptionDataPointNames];
var dataPoints18 = nascarOptionDataPoints;
var nascarPostDataSourceConfig = {
  name: "Post",
  points: dataPoints18,
  dataType: "MARKET",
  type: typeName17
};

// src/Direct/CarRacing/Nascar/Qualification/index.ts
var typeName18 = "NASCAR_QUALIFICATION";
var dataPointNames19 = [...nascarOptionDataPointNames];
var dataPoints19 = nascarOptionDataPoints;
var nascarQualificationDataSourceConfig = {
  name: "Qualification",
  points: dataPoints19,
  dataType: "MARKET",
  type: typeName18
};

// src/Direct/CarRacing/Nascar/Delay/index.ts
var typeName19 = "NASCAR_DELAY";
var dataPointNames20 = [];
var dataPoints20 = [];
var nascarDelayDataSourceConfig = {
  name: "Race Delay",
  points: dataPoints20,
  dataType: "MARKET",
  type: typeName19
};

// src/Direct/CarRacing/Nascar/FastestLap/index.ts
var typeName20 = "NASCAR_FASTEST_LAP";
var dataPointNames21 = [
  ...nascarOptionDataPointNames,
  ...nascarMomentDriverDataPointNames,
  "MOMENT_FASTEST_LAP",
  "MOMENT_FASTEST_LAP_TIME"
];
var dataPoints21 = [
  ...nascarOptionDataPoints,
  ...nascarMomentDriverDataPoints,
  { name: "MOMENT_FASTEST_LAP", type: "TEXT", autoImportName: "MOMENT_FASTEST_LAP" },
  { name: "MOMENT_FASTEST_LAP_TIME", type: "TEXT", autoImportName: "MOMENT_FASTEST_LAP_TIME" }
];
var nascarFastestLapDataSourceConfig = {
  name: "Fastest Lap",
  points: dataPoints21,
  dataType: "MARKET",
  type: typeName20
};

// src/Direct/CarRacing/Nascar/StageWinner/index.ts
var typeName21 = "NASCAR_STAGE_WINNER";
var dataPointNames22 = [
  ...nascarOptionDataPointNames,
  ...nascarMomentDriverDataPointNames,
  "MOMENT_POSITION",
  "MOMENT_STAGE_NUMBER",
  "MOMENT_STAGE_LAPS_TOTAL",
  "MOMENT_STAGE_LAPS_COMPLETED"
];
var dataPoints22 = [
  ...nascarOptionDataPoints,
  ...nascarMomentDriverDataPoints,
  { name: "MOMENT_POSITION", type: "TEXT", autoImportName: "MOMENT_POSITION" },
  { name: "MOMENT_STAGE_NUMBER", type: "TEXT", autoImportName: "MOMENT_STAGE_NUMBER" },
  { name: "MOMENT_STAGE_LAPS_TOTAL", type: "TEXT", autoImportName: "MOMENT_STAGE_LAPS_TOTAL" },
  {
    name: "MOMENT_STAGE_LAPS_COMPLETED",
    type: "TEXT",
    autoImportName: "MOMENT_STAGE_LAPS_COMPLETED"
  }
];
var nascarStageWinnerDataSourceConfig = {
  name: "Stage Winner",
  points: dataPoints22,
  dataType: "MARKET",
  type: typeName21
};

// src/Direct/CarRacing/Nascar/RaceWinner/index.ts
var typeName22 = "NASCAR_RACE_WINNER";
var dataPointNames23 = [
  ...nascarOptionDataPointNames,
  ...nascarMomentDriverDataPointNames,
  "MOMENT_POSITION"
];
var dataPoints23 = [
  ...nascarOptionDataPoints,
  ...nascarMomentDriverDataPoints,
  { name: "MOMENT_POSITION", type: "TEXT", autoImportName: "MOMENT_POSITION" }
];
var nascarRaceWinnerDataSourceConfig = {
  name: "Race Winner",
  points: dataPoints23,
  dataType: "MARKET",
  type: typeName22
};

// src/Direct/CarRacing/Nascar/TopTenFinish/index.ts
var typeName23 = "NASCAR_TOP_TEN_FINISH";
var dataPointNames24 = [
  ...nascarOptionDataPointNames,
  ...nascarMomentDriverDataPointNames,
  "MOMENT_POSITION"
];
var dataPoints24 = [
  ...nascarOptionDataPoints,
  ...nascarMomentDriverDataPoints,
  { name: "MOMENT_POSITION", type: "TEXT", autoImportName: "MOMENT_POSITION" }
];
var nascarTopTenFinishDataSourceConfig = {
  name: "Top 10 Finish",
  points: dataPoints24,
  dataType: "MARKET",
  type: typeName23
};

// src/Direct/CarRacing/Nascar/index.ts
var typeName24 = "NASCAR";
var dataPointNames25 = ["SOMETHING", "SOMETHING_ELSE"];
var dataPoints25 = [
  { name: "SOMETHING", type: "TEXT", autoImportName: "SOMETHING" },
  { name: "SOMETHING_ELSE", type: "TEXT", autoImportName: "SOMETHING_ELSE" }
];
var dataSourceConfig15 = {
  name: "Nascar",
  points: dataPoints25,
  dataType: "TEMPLATE",
  type: typeName24
};
var NascarStages = {
  COUNTDOWN: "COUNTDOWN",
  DELAY: "DELAY",
  QUALIFICATION: "QUALIFICATION",
  LIVE: "LIVE",
  STAGE_WINNER: "STAGE_WINNER",
  FASTEST_LAP: "FASTEST_LAP",
  POST: "POST",
  RACE_WINNER: "RACE_WINNER",
  TOP_TEN_FINISH: "TOP_TEN_FINISH"
};
var nascarCompetition = {
  commonDataSource: dataSourceConfig15,
  stages: {
    [NascarStages.COUNTDOWN]: nascarCountdownDataSourceConfig,
    [NascarStages.DELAY]: nascarDelayDataSourceConfig,
    [NascarStages.QUALIFICATION]: nascarQualificationDataSourceConfig,
    [NascarStages.LIVE]: nascarLiveDataSourceConfig,
    [NascarStages.STAGE_WINNER]: nascarStageWinnerDataSourceConfig,
    [NascarStages.FASTEST_LAP]: nascarFastestLapDataSourceConfig,
    [NascarStages.POST]: nascarPostDataSourceConfig,
    [NascarStages.RACE_WINNER]: nascarRaceWinnerDataSourceConfig,
    [NascarStages.TOP_TEN_FINISH]: nascarTopTenFinishDataSourceConfig
  }
};

// src/Direct/SportsMoments/NBA/PreEvent/index.ts
var typeName25 = "NBA_PRE_EVENT";
var dataPointNames26 = [
  "PRE_COUNTDOWN",
  "PRE_TEAM_HOME_WINS",
  "PRE_TEAM_HOME_LOSSES",
  "PRE_TEAM_AWAY_WINS",
  "PRE_TEAM_AWAY_LOSSES"
];
var dataPoints26 = [
  { name: "PRE_COUNTDOWN", type: "TEXT", autoImportName: "PRE_COUNTDOWN" },
  {
    name: "PRE_TEAM_HOME_WINS",
    type: "TEXT",
    autoImportName: "PRE_TEAM_HOME_WINS"
  },
  {
    name: "PRE_TEAM_HOME_LOSSES",
    type: "TEXT",
    autoImportName: "PRE_TEAM_HOME_LOSSES"
  },
  { name: "PRE_TEAM_AWAY_WINS", type: "TEXT", autoImportName: "PRE_TEAM_AWAY_WINS" },
  {
    name: "PRE_TEAM_AWAY_LOSSES",
    type: "TEXT",
    autoImportName: "PRE_TEAM_AWAY_LOSSES"
  }
];
var preEventDataSourceConfig = {
  name: "Pre-Event",
  points: dataPoints26,
  dataType: "MARKET",
  type: typeName25
};

// src/Direct/SportsMoments/NBA/Live/index.ts
var typeName26 = "NBA_LIVE";
var dataPointNames27 = [
  "LIVE_FULL_SCORE",
  "LIVE_TEAM_HOME_SCORE",
  "LIVE_TEAM_AWAY_SCORE",
  "LIVE_TOP_POINTS_PLAYER_NAME",
  "LIVE_TOP_POINTS_PLAYER_TEAM",
  "LIVE_TOP_POINTS_PLAYER_COUNT"
];
var dataPoints27 = [
  { name: "LIVE_FULL_SCORE", type: "TEXT", autoImportName: "LIVE_FULL_SCORE" },
  {
    name: "LIVE_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "LIVE_TEAM_HOME_SCORE"
  },
  { name: "LIVE_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "LIVE_TEAM_AWAY_SCORE" },
  {
    name: "LIVE_TOP_POINTS_PLAYER_NAME",
    type: "TEXT",
    autoImportName: "LIVE_TOP_POINTS_PLAYER_NAME"
  },
  {
    name: "LIVE_TOP_POINTS_PLAYER_TEAM",
    type: "TEXT",
    autoImportName: "LIVE_TOP_POINTS_PLAYER_TEAM"
  },
  {
    name: "LIVE_TOP_POINTS_PLAYER_COUNT",
    type: "TEXT",
    autoImportName: "LIVE_TOP_POINTS_PLAYER_COUNT"
  }
];
var liveDataSourceConfig = {
  name: "Live",
  points: dataPoints27,
  dataType: "MARKET",
  type: typeName26
};

// src/Direct/SportsMoments/NBA/PostEvent/index.ts
var typeName27 = "NBA_POST_EVENT";
var dataPointNames28 = [
  "POST_FULL_SCORE",
  "POST_TEAM_HOME_SCORE",
  "POST_TEAM_AWAY_SCORE",
  "POST_TOP_POINTS_PLAYER_NAME",
  "POST_TOP_POINTS_PLAYER_TEAM",
  "POST_TOP_POINTS_PLAYER_COUNT"
];
var dataPoints28 = [
  { name: "POST_FULL_SCORE", type: "TEXT", autoImportName: "POST_FULL_SCORE" },
  {
    name: "POST_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "POST_TEAM_HOME_SCORE"
  },
  { name: "POST_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "POST_TEAM_AWAY_SCORE" },
  {
    name: "POST_TOP_POINTS_PLAYER_NAME",
    type: "TEXT",
    autoImportName: "POST_TOP_POINTS_PLAYER_NAME"
  },
  {
    name: "POST_TOP_POINTS_PLAYER_TEAM",
    type: "TEXT",
    autoImportName: "POST_TOP_POINTS_PLAYER_TEAM"
  },
  {
    name: "POST_TOP_POINTS_PLAYER_COUNT",
    type: "TEXT",
    autoImportName: "POST_TOP_POINTS_PLAYER_COUNT"
  }
];
var postEventDataSourceConfig = {
  name: "Post-Event",
  points: dataPoints28,
  dataType: "MARKET",
  type: typeName27
};

// src/Direct/Casino/index.ts
var typeName28 = "CASINO";
var dataPointNames29 = ["LANDSCAPE_IMAGE", "SQUARE_IMAGE", "PORTRAIT_IMAGE"];
var dataPoints29 = [
  {
    name: "LANDSCAPE_IMAGE",
    type: "CASINO_ASSET",
    autoImportName: "LANDSCAPE_IMAGE"
  },
  {
    name: "SQUARE_IMAGE",
    type: "CASINO_ASSET",
    autoImportName: "SQUARE_IMAGE"
  },
  {
    name: "PORTRAIT_IMAGE",
    type: "CASINO_ASSET",
    autoImportName: "PORTRAIT_IMAGE"
  }
];
var dataSourceConfig16 = {
  name: "Casino",
  points: dataPoints29,
  dataType: "TEMPLATE",
  type: typeName28
};

// src/Direct/SportsMoments/NBA/index.ts
var typeName29 = "NBA";
var dataPointNames30 = [
  "TEAM_HOME_NAME",
  "TEAM_AWAY_NAME",
  "TEAM_HOME_NAME_SHORT",
  "TEAM_AWAY_NAME_SHORT",
  "TEAM_HOME_NAME_FULL",
  "TEAM_AWAY_NAME_FULL"
];
var dataPoints30 = [
  { name: "TEAM_HOME_NAME", type: "TEXT", autoImportName: "TEAM_HOME_NAME" },
  { name: "TEAM_AWAY_NAME", type: "TEXT", autoImportName: "TEAM_AWAY_NAME" },
  { name: "TEAM_HOME_NAME_SHORT", type: "TEXT", autoImportName: "TEAM_HOME_NAME_SHORT" },
  { name: "TEAM_AWAY_NAME_SHORT", type: "TEXT", autoImportName: "TEAM_AWAY_NAME_SHORT" },
  { name: "TEAM_HOME_NAME_FULL", type: "TEXT", autoImportName: "TEAM_HOME_NAME_FULL" },
  { name: "TEAM_AWAY_NAME_FULL", type: "TEXT", autoImportName: "TEAM_AWAY_NAME_FULL" }
];
var dataSourceConfig17 = {
  name: "Basketball (NBA)",
  points: dataPoints30,
  dataType: "TEMPLATE",
  type: typeName29
};
var NBACompetition = {
  commonDataSource: dataSourceConfig17,
  stages: {
    ["PRE_EVENT" /* PRE_EVENT */]: preEventDataSourceConfig,
    ["LIVE" /* LIVE */]: liveDataSourceConfig,
    ["POST_EVENT" /* POST_EVENT */]: postEventDataSourceConfig
  }
};

// src/Direct/SportsMoments/Soccer/PreEvent/index.ts
var typeName30 = "SOCCER_PRE";
var dataPointNames31 = ["COUNTDOWN"];
var dataPoints31 = [
  { name: "COUNTDOWN", type: "TEXT", autoImportName: "COUNTDOWN" }
];
var preEventDataSourceConfig2 = {
  name: "Pre-Event",
  points: dataPoints31,
  dataType: "MARKET",
  type: typeName30
};

// src/Direct/SportsMoments/Soccer/Live/index.ts
var typeName31 = "SOCCER_LIVE";
var dataPointNames32 = ["LIVE_TEAM_HOME_SCORE", "LIVE_TEAM_AWAY_SCORE"];
var dataPoints32 = [
  {
    name: "LIVE_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "LIVE_TEAM_HOME_SCORE"
  },
  { name: "LIVE_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "LIVE_TEAM_AWAY_SCORE" }
];
var liveDataSourceConfig2 = {
  name: "Live",
  points: dataPoints32,
  dataType: "MARKET",
  type: typeName31
};

// src/Direct/SportsMoments/Soccer/LiveGoal/index.ts
var typeName32 = "SOCCER_LIVE_GOAL";
var dataPointNames33 = [
  "LIVE_TEAM_HOME_SCORE",
  "LIVE_TEAM_AWAY_SCORE",
  "MOMENT_GOAL_SCORER_NAME",
  "MOMENT_GOAL_MATCH_TIME",
  "MOMENT_GOAL_TEAM_COMPETITOR_ID"
];
var dataPoints33 = [
  {
    name: "LIVE_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "LIVE_TEAM_HOME_SCORE"
  },
  { name: "LIVE_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "LIVE_TEAM_AWAY_SCORE" },
  {
    name: "MOMENT_GOAL_SCORER_NAME",
    type: "TEXT",
    autoImportName: "MOMENT_GOAL_SCORER_NAME"
  },
  {
    name: "MOMENT_GOAL_MATCH_TIME",
    type: "TEXT",
    autoImportName: "MOMENT_GOAL_MATCH_TIME"
  },
  {
    name: "MOMENT_GOAL_TEAM_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["MOMENT_GOAL_TEAM_COMPETITOR_ID", "GOAL_CUSTOM"]
  }
];
var liveGoalDataSourceConfig = {
  name: "Live Goal",
  points: dataPoints33,
  dataType: "MARKET",
  type: typeName32
};

// src/Direct/SportsMoments/Soccer/PostEvent/index.ts
var typeName33 = "SOCCER_POST";
var dataPointNames34 = [
  "POST_TEAM_HOME_SCORE",
  "POST_TEAM_AWAY_SCORE",
  "POST_EVENT_OUTCOME"
];
var dataPoints34 = [
  {
    name: "POST_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "POST_TEAM_HOME_SCORE"
  },
  { name: "POST_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "POST_TEAM_AWAY_SCORE" },
  {
    name: "POST_EVENT_OUTCOME",
    type: "TEXT",
    autoImportName: "POST_EVENT_OUTCOME"
  }
];
var postEventDataSourceConfig2 = {
  name: "Post-Event",
  points: dataPoints34,
  dataType: "MARKET",
  type: typeName33
};

// src/Direct/SportsMoments/Soccer/PostWinner/index.ts
var typeName34 = "SOCCER_POST_WINNER";
var dataPointNames35 = [
  "POST_TEAM_HOME_SCORE",
  "POST_TEAM_AWAY_SCORE",
  "POST_EVENT_OUTCOME",
  "POST_WINNER_TEAM_NAME",
  "POST_WINNER_TEAM_COMPETITOR_ID"
];
var dataPoints35 = [
  {
    name: "POST_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "POST_TEAM_HOME_SCORE"
  },
  { name: "POST_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "POST_TEAM_AWAY_SCORE" },
  {
    name: "POST_EVENT_OUTCOME",
    type: "TEXT",
    autoImportName: "POST_EVENT_OUTCOME"
  },
  {
    name: "POST_WINNER_TEAM_NAME",
    type: "TEXT",
    autoImportName: "POST_WINNER_TEAM_NAME"
  },
  {
    name: "POST_WINNER_TEAM_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["POST_WINNER_TEAM_COMPETITOR_ID", "WINNING_CUSTOM"]
  }
];
var postWinnerDataSourceConfig = {
  name: "Post Winner",
  points: dataPoints35,
  dataType: "MARKET",
  type: typeName34
};

// src/Direct/SportsMoments/Soccer/index.ts
var typeName35 = "SOCCER";
var dataPointNames36 = [
  "TEAM_HOME_NAME",
  "TEAM_AWAY_NAME",
  "TEAM_HOME_ABBREVIATION",
  "TEAM_AWAY_ABBREVIATION",
  "TEAM_HOME_COMPETITOR_ID",
  "TEAM_AWAY_COMPETITOR_ID",
  "EVENT_ROUND_NAME",
  "MATCH_STATUS",
  "DAY",
  "DATE",
  "MONTH",
  "TIME",
  "LOTTERY_POWERBALL_JACKPOT",
  "LOTTERY_GERMAN6AUS49_JACKPOT"
];
var dataPoints36 = [
  { name: "TEAM_HOME_NAME", type: "TEXT", autoImportName: "TEAM_HOME_NAME" },
  { name: "TEAM_AWAY_NAME", type: "TEXT", autoImportName: "TEAM_AWAY_NAME" },
  { name: "TEAM_HOME_ABBREVIATION", type: "TEXT", autoImportName: "TEAM_HOME_ABBREVIATION" },
  { name: "TEAM_AWAY_ABBREVIATION", type: "TEXT", autoImportName: "TEAM_AWAY_ABBREVIATION" },
  {
    name: "TEAM_HOME_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["TEAM_HOME_COMPETITOR_ID", "HOME_CUSTOM"]
  },
  {
    name: "TEAM_AWAY_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["TEAM_AWAY_COMPETITOR_ID", "AWAY_CUSTOM"]
  },
  { name: "EVENT_ROUND_NAME", type: "TEXT", autoImportName: "EVENT_ROUND_NAME" },
  { name: "MATCH_STATUS", type: "TEXT", autoImportName: "MATCH_STATUS" },
  { name: "DAY", type: "TEXT", autoImportName: "DAY" },
  { name: "DATE", type: "TEXT", autoImportName: "DATE" },
  { name: "MONTH", type: "TEXT", autoImportName: "MONTH" },
  { name: "TIME", type: "TEXT", autoImportName: "TIME" },
  {
    name: "LOTTERY_POWERBALL_JACKPOT",
    type: "TEXT",
    autoImportName: "LOTTERY_POWERBALL_JACKPOT"
  },
  {
    name: "LOTTERY_GERMAN6AUS49_JACKPOT",
    type: "TEXT",
    autoImportName: "LOTTERY_GERMAN6AUS49_JACKPOT"
  }
];
var dataSourceConfig18 = {
  name: "Soccer",
  points: dataPoints36,
  dataType: "TEMPLATE",
  type: typeName35
};
var SoccerStages = /* @__PURE__ */ ((SoccerStages4) => {
  SoccerStages4["PRE_EVENT"] = "PRE_EVENT";
  SoccerStages4["LIVE"] = "LIVE";
  SoccerStages4["LIVE_GOAL"] = "LIVE_GOAL";
  SoccerStages4["POST_EVENT"] = "POST_EVENT";
  SoccerStages4["POST_WINNER"] = "POST_WINNER";
  return SoccerStages4;
})(SoccerStages || {});
var SoccerCompetition = {
  commonDataSource: dataSourceConfig18,
  stages: {
    ["PRE_EVENT" /* PRE_EVENT */]: preEventDataSourceConfig2,
    ["LIVE" /* LIVE */]: liveDataSourceConfig2,
    ["LIVE_GOAL" /* LIVE_GOAL */]: liveGoalDataSourceConfig,
    ["POST_EVENT" /* POST_EVENT */]: postEventDataSourceConfig2,
    ["POST_WINNER" /* POST_WINNER */]: postWinnerDataSourceConfig
  }
};
var SOCCER_STAGE_ORDER = [
  "PRE_EVENT" /* PRE_EVENT */,
  "LIVE" /* LIVE */,
  "LIVE_GOAL" /* LIVE_GOAL */,
  "POST_EVENT" /* POST_EVENT */,
  "POST_WINNER" /* POST_WINNER */
];
var soccerStageSelectOptions = SOCCER_STAGE_ORDER.map((value) => ({
  value,
  label: SoccerCompetition.stages[value].name
}));

// src/Direct/SportsMoments/NFL/PreEvent/index.ts
var typeName36 = "NFL_PRE";
var dataPointNames37 = ["COUNTDOWN", "INSIGHTS_SHORT"];
var dataPoints37 = [
  { name: "COUNTDOWN", type: "TEXT", autoImportName: "COUNTDOWN" },
  // Supplied by the Sports Data API; Branded Insights are generated separately by AI.
  { name: "INSIGHTS_SHORT", type: "TEXT", autoImportName: "INSIGHTS_SHORT" }
];
var preEventDataSourceConfig3 = {
  name: "Pre-Event",
  points: dataPoints37,
  dataType: "MARKET",
  type: typeName36
};

// src/Direct/SportsMoments/NFL/Live/index.ts
var typeName37 = "NFL_LIVE";
var dataPointNames38 = [
  "LIVE_TEAM_HOME_SCORE",
  "LIVE_TEAM_AWAY_SCORE",
  "LIVE_MATCH_TIME",
  "LIVE_MATCH_QUARTER"
];
var dataPoints38 = [
  {
    name: "LIVE_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "LIVE_TEAM_HOME_SCORE"
  },
  { name: "LIVE_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "LIVE_TEAM_AWAY_SCORE" },
  { name: "LIVE_MATCH_TIME", type: "TEXT", autoImportName: "LIVE_MATCH_TIME" },
  { name: "LIVE_MATCH_QUARTER", type: "TEXT", autoImportName: "LIVE_MATCH_QUARTER" }
];
var liveDataSourceConfig3 = {
  name: "Live",
  points: dataPoints38,
  dataType: "MARKET",
  type: typeName37
};

// src/Direct/SportsMoments/NFL/LiveTouchdown/index.ts
var typeName38 = "NFL_LIVE_TOUCHDOWN";
var dataPointNames39 = [
  "LIVE_TEAM_HOME_SCORE",
  "LIVE_TEAM_AWAY_SCORE",
  "LIVE_MATCH_TIME",
  "LIVE_MATCH_QUARTER",
  "MOMENT_TOUCHDOWN_SCORER_NAME",
  "MOMENT_TOUCHDOWN_TEAM_NAME",
  "MOMENT_TOUCHDOWN_TEAM_MARKET",
  "MOMENT_TOUCHDOWN_TEAM_SR_ID",
  "MOMENT_TOUCHDOWN_SCORER_SR_ID",
  // Parse-only: legacy bindings on templates saved before the SD-aligned rename.
  "MOMENT_TOUCHDOWN_TEAM_COMPETITOR_ID",
  "MOMENT_TOUCHDOWN_PLAYER_ID"
];
var dataPoints39 = [
  {
    name: "LIVE_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "LIVE_TEAM_HOME_SCORE"
  },
  { name: "LIVE_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "LIVE_TEAM_AWAY_SCORE" },
  { name: "LIVE_MATCH_TIME", type: "TEXT", autoImportName: "LIVE_MATCH_TIME" },
  { name: "LIVE_MATCH_QUARTER", type: "TEXT", autoImportName: "LIVE_MATCH_QUARTER" },
  {
    name: "MOMENT_TOUCHDOWN_SCORER_NAME",
    type: "TEXT",
    autoImportName: "MOMENT_TOUCHDOWN_SCORER_NAME"
  },
  {
    name: "MOMENT_TOUCHDOWN_TEAM_NAME",
    type: "TEXT",
    autoImportName: "MOMENT_TOUCHDOWN_TEAM_NAME"
  },
  {
    name: "MOMENT_TOUCHDOWN_TEAM_MARKET",
    type: "TEXT",
    autoImportName: "MOMENT_TOUCHDOWN_TEAM_MARKET"
  },
  {
    name: "MOMENT_TOUCHDOWN_TEAM_SR_ID",
    type: "IMAGE",
    autoImportName: ["MOMENT_TOUCHDOWN_TEAM_SR_ID", "TOUCHDOWN_CUSTOM"]
  },
  {
    name: "MOMENT_TOUCHDOWN_SCORER_SR_ID",
    type: "IMAGE",
    autoImportName: ["MOMENT_TOUCHDOWN_SCORER_SR_ID", "TOUCHDOWN_PLAYER_CUSTOM"]
  }
];
var liveTouchdownDataSourceConfig = {
  name: "Live Touchdown",
  points: dataPoints39,
  dataType: "MARKET",
  type: typeName38
};

// src/Direct/SportsMoments/NFL/PostEvent/index.ts
var typeName39 = "NFL_POST";
var dataPointNames40 = [
  "POST_TEAM_HOME_SCORE",
  "POST_TEAM_AWAY_SCORE",
  "POST_EVENT_OUTCOME",
  "POST_NEXT_MATCH_HOME_NAME",
  "POST_NEXT_MATCH_AWAY_NAME",
  "POST_NEXT_MATCH_HOME_MARKET",
  "POST_NEXT_MATCH_AWAY_MARKET",
  "POST_NEXT_MATCH_HOME_ABBREVIATION",
  "POST_NEXT_MATCH_AWAY_ABBREVIATION"
];
var dataPoints40 = [
  {
    name: "POST_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "POST_TEAM_HOME_SCORE"
  },
  { name: "POST_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "POST_TEAM_AWAY_SCORE" },
  {
    name: "POST_EVENT_OUTCOME",
    type: "TEXT",
    autoImportName: "POST_EVENT_OUTCOME"
  },
  {
    name: "POST_NEXT_MATCH_HOME_NAME",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_NAME"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_NAME",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_NAME"
  },
  {
    name: "POST_NEXT_MATCH_HOME_MARKET",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_MARKET"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_MARKET",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_MARKET"
  },
  {
    name: "POST_NEXT_MATCH_HOME_ABBREVIATION",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_ABBREVIATION"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_ABBREVIATION",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_ABBREVIATION"
  }
];
var postEventDataSourceConfig3 = {
  name: "Post-Event",
  points: dataPoints40,
  dataType: "MARKET",
  type: typeName39
};

// src/Direct/SportsMoments/NFL/PostWinner/index.ts
var typeName40 = "NFL_POST_WINNER";
var dataPointNames41 = [
  "POST_TEAM_HOME_SCORE",
  "POST_TEAM_AWAY_SCORE",
  "POST_EVENT_OUTCOME",
  "POST_WINNER_TEAM_NAME",
  "POST_WINNER_TEAM_MARKET",
  "POST_WINNER_TEAM_COMPETITOR_ID",
  "POST_NEXT_MATCH_HOME_NAME",
  "POST_NEXT_MATCH_AWAY_NAME",
  "POST_NEXT_MATCH_HOME_MARKET",
  "POST_NEXT_MATCH_AWAY_MARKET",
  "POST_NEXT_MATCH_HOME_ABBREVIATION",
  "POST_NEXT_MATCH_AWAY_ABBREVIATION"
];
var dataPoints41 = [
  {
    name: "POST_TEAM_HOME_SCORE",
    type: "TEXT",
    autoImportName: "POST_TEAM_HOME_SCORE"
  },
  { name: "POST_TEAM_AWAY_SCORE", type: "TEXT", autoImportName: "POST_TEAM_AWAY_SCORE" },
  {
    name: "POST_EVENT_OUTCOME",
    type: "TEXT",
    autoImportName: "POST_EVENT_OUTCOME"
  },
  {
    name: "POST_WINNER_TEAM_NAME",
    type: "TEXT",
    autoImportName: "POST_WINNER_TEAM_NAME"
  },
  {
    name: "POST_WINNER_TEAM_MARKET",
    type: "TEXT",
    autoImportName: "POST_WINNER_TEAM_MARKET"
  },
  {
    name: "POST_WINNER_TEAM_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["POST_WINNER_TEAM_COMPETITOR_ID", "WINNING_CUSTOM"]
  },
  {
    name: "POST_NEXT_MATCH_HOME_NAME",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_NAME"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_NAME",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_NAME"
  },
  {
    name: "POST_NEXT_MATCH_HOME_MARKET",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_MARKET"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_MARKET",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_MARKET"
  },
  {
    name: "POST_NEXT_MATCH_HOME_ABBREVIATION",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_HOME_ABBREVIATION"
  },
  {
    name: "POST_NEXT_MATCH_AWAY_ABBREVIATION",
    type: "TEXT",
    autoImportName: "POST_NEXT_MATCH_AWAY_ABBREVIATION"
  }
];
var postWinnerDataSourceConfig2 = {
  name: "Post Winner",
  points: dataPoints41,
  dataType: "MARKET",
  type: typeName40
};

// src/Direct/SportsMoments/NFL/index.ts
var typeName41 = "NFL";
var dataPointNames42 = [
  "TEAM_HOME_NAME",
  "TEAM_AWAY_NAME",
  "TEAM_HOME_MARKET",
  "TEAM_AWAY_MARKET",
  "TEAM_HOME_ABBREVIATION",
  "TEAM_AWAY_ABBREVIATION",
  "TEAM_HOME_COMPETITOR_ID",
  "TEAM_AWAY_COMPETITOR_ID",
  "MATCH_STATUS",
  "DAY",
  "DATE",
  "MONTH",
  "TIME"
];
var dataPoints42 = [
  { name: "TEAM_HOME_NAME", type: "TEXT", autoImportName: "TEAM_HOME_NAME" },
  { name: "TEAM_AWAY_NAME", type: "TEXT", autoImportName: "TEAM_AWAY_NAME" },
  { name: "TEAM_HOME_MARKET", type: "TEXT", autoImportName: "TEAM_HOME_MARKET" },
  { name: "TEAM_AWAY_MARKET", type: "TEXT", autoImportName: "TEAM_AWAY_MARKET" },
  { name: "TEAM_HOME_ABBREVIATION", type: "TEXT", autoImportName: "TEAM_HOME_ABBREVIATION" },
  { name: "TEAM_AWAY_ABBREVIATION", type: "TEXT", autoImportName: "TEAM_AWAY_ABBREVIATION" },
  {
    name: "TEAM_HOME_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["TEAM_HOME_COMPETITOR_ID", "HOME_CUSTOM"]
  },
  {
    name: "TEAM_AWAY_COMPETITOR_ID",
    type: "IMAGE",
    autoImportName: ["TEAM_AWAY_COMPETITOR_ID", "AWAY_CUSTOM"]
  },
  { name: "MATCH_STATUS", type: "TEXT", autoImportName: "MATCH_STATUS" },
  { name: "DAY", type: "TEXT", autoImportName: "DAY" },
  { name: "DATE", type: "TEXT", autoImportName: "DATE" },
  { name: "MONTH", type: "TEXT", autoImportName: "MONTH" },
  { name: "TIME", type: "TEXT", autoImportName: "TIME" }
];
var dataSourceConfig19 = {
  name: "American Football (NFL)",
  points: dataPoints42,
  dataType: "TEMPLATE",
  type: typeName41
};
var NFLStages = /* @__PURE__ */ ((NFLStages4) => {
  NFLStages4["PRE_EVENT"] = "PRE_EVENT";
  NFLStages4["LIVE"] = "LIVE";
  NFLStages4["LIVE_TOUCHDOWN"] = "LIVE_TOUCHDOWN";
  NFLStages4["POST_EVENT"] = "POST_EVENT";
  NFLStages4["POST_WINNER"] = "POST_WINNER";
  return NFLStages4;
})(NFLStages || {});
var NFLCompetition = {
  commonDataSource: dataSourceConfig19,
  stages: {
    ["PRE_EVENT" /* PRE_EVENT */]: preEventDataSourceConfig3,
    ["LIVE" /* LIVE */]: liveDataSourceConfig3,
    ["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */]: liveTouchdownDataSourceConfig,
    ["POST_EVENT" /* POST_EVENT */]: postEventDataSourceConfig3,
    ["POST_WINNER" /* POST_WINNER */]: postWinnerDataSourceConfig2
  }
};
var NFL_STAGE_ORDER = [
  "PRE_EVENT" /* PRE_EVENT */,
  "LIVE" /* LIVE */,
  "LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */,
  "POST_EVENT" /* POST_EVENT */,
  "POST_WINNER" /* POST_WINNER */
];
var nflStageSelectOptions = NFL_STAGE_ORDER.map((value) => ({
  value,
  label: NFLCompetition.stages[value].name
}));

// src/Direct/Datasources.ts
var sourceTypes2 = [
  typeName29,
  typeName25,
  typeName26,
  typeName27,
  typeName35,
  typeName30,
  typeName31,
  typeName32,
  typeName33,
  typeName34,
  typeName41,
  typeName36,
  typeName37,
  typeName38,
  typeName39,
  typeName40,
  typeName24,
  typeName15,
  typeName16,
  typeName17,
  typeName18,
  typeName19,
  typeName20,
  typeName21,
  typeName22,
  typeName23,
  typeName28
];
var combinedDP2 = [
  ...dataPointNames30,
  ...dataPointNames26,
  ...dataPointNames27,
  ...dataPointNames28,
  ...dataPointNames36,
  ...dataPointNames31,
  ...dataPointNames32,
  ...dataPointNames33,
  ...dataPointNames34,
  ...dataPointNames35,
  ...dataPointNames42,
  ...dataPointNames37,
  ...dataPointNames38,
  ...dataPointNames39,
  ...dataPointNames40,
  ...dataPointNames41,
  ...dataPointNames25,
  ...dataPointNames16,
  ...dataPointNames17,
  ...dataPointNames18,
  ...dataPointNames19,
  ...dataPointNames20,
  ...dataPointNames21,
  ...dataPointNames22,
  ...dataPointNames23,
  ...dataPointNames24,
  ...dataPointNames29
];
var typeMap = {
  [NBACompetition.commonDataSource.type]: "",
  [NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "",
  [NBACompetition.stages["LIVE" /* LIVE */].type]: "",
  [NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "",
  [SoccerCompetition.commonDataSource.type]: "",
  [SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "",
  [SoccerCompetition.stages["LIVE" /* LIVE */].type]: "",
  [SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type]: "",
  [SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "",
  [SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "",
  [NFLCompetition.commonDataSource.type]: "",
  [NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "",
  [NFLCompetition.stages["LIVE" /* LIVE */].type]: "",
  [NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type]: "",
  [NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "",
  [NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "",
  [nascarCompetition.commonDataSource.type]: "",
  [nascarCompetition.stages[NascarStages.COUNTDOWN].type]: "",
  [nascarCompetition.stages[NascarStages.LIVE].type]: "",
  [nascarCompetition.stages[NascarStages.POST].type]: "",
  [nascarCompetition.stages[NascarStages.QUALIFICATION].type]: "",
  [nascarCompetition.stages[NascarStages.DELAY].type]: "",
  [nascarCompetition.stages[NascarStages.FASTEST_LAP].type]: "",
  [nascarCompetition.stages[NascarStages.STAGE_WINNER].type]: "",
  [nascarCompetition.stages[NascarStages.RACE_WINNER].type]: "",
  [nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type]: "",
  [typeName28]: ""
};
var marketDataTypes = [
  NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type,
  NBACompetition.stages["LIVE" /* LIVE */].type,
  NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type,
  SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type,
  SoccerCompetition.stages["LIVE" /* LIVE */].type,
  SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type,
  SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type,
  SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type,
  NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type,
  NFLCompetition.stages["LIVE" /* LIVE */].type,
  NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type,
  NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type,
  NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type,
  nascarCompetition.stages[NascarStages.COUNTDOWN].type,
  nascarCompetition.stages[NascarStages.LIVE].type,
  nascarCompetition.stages[NascarStages.POST].type,
  nascarCompetition.stages[NascarStages.QUALIFICATION].type,
  nascarCompetition.stages[NascarStages.DELAY].type,
  nascarCompetition.stages[NascarStages.FASTEST_LAP].type,
  nascarCompetition.stages[NascarStages.STAGE_WINNER].type,
  nascarCompetition.stages[NascarStages.RACE_WINNER].type,
  nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type,
  typeName28
];
var normalisedMarketNames2 = {
  [NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "NBA Pre-Event",
  [NBACompetition.stages["LIVE" /* LIVE */].type]: "NBA Live",
  [NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "NBA Post-Event",
  [SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "Pre-Event",
  [SoccerCompetition.stages["LIVE" /* LIVE */].type]: "Live",
  [SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type]: "Live Goal",
  [SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "Post-Event",
  [SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "Post Winner",
  [NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "NFL Pre-Event",
  [NFLCompetition.stages["LIVE" /* LIVE */].type]: "NFL Live",
  [NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type]: "NFL Live Touchdown",
  [NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "NFL Post-Event",
  [NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "NFL Post Winner",
  [nascarCompetition.stages[NascarStages.COUNTDOWN].type]: "Countdown",
  [nascarCompetition.stages[NascarStages.LIVE].type]: "Live",
  [nascarCompetition.stages[NascarStages.POST].type]: "Post",
  [nascarCompetition.stages[NascarStages.QUALIFICATION].type]: "Qualification",
  [nascarCompetition.stages[NascarStages.DELAY].type]: "Race Delay",
  [nascarCompetition.stages[NascarStages.FASTEST_LAP].type]: "Fastest Lap",
  [nascarCompetition.stages[NascarStages.STAGE_WINNER].type]: "Stage Winner",
  [nascarCompetition.stages[NascarStages.RACE_WINNER].type]: "Race Winner",
  [nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type]: "Top 10 Finish",
  [typeName28]: "Casino"
};
var dataSourcesConfigs2 = [
  NBACompetition.commonDataSource,
  ...Object.values(NBACompetition.stages),
  SoccerCompetition.commonDataSource,
  ...Object.values(SoccerCompetition.stages),
  NFLCompetition.commonDataSource,
  ...Object.values(NFLCompetition.stages),
  dataSourceConfig15,
  ...Object.values(nascarCompetition.stages),
  dataSourceConfig16
];
var mapDataTypesFromSourceTypes2 = {
  [NBACompetition.commonDataSource.type]: "TEMPLATE",
  [NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "MARKET",
  [NBACompetition.stages["LIVE" /* LIVE */].type]: "MARKET",
  [NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "MARKET",
  [SoccerCompetition.commonDataSource.type]: "TEMPLATE",
  [SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "MARKET",
  [SoccerCompetition.stages["LIVE" /* LIVE */].type]: "MARKET",
  [SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type]: "MARKET",
  [SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "MARKET",
  [SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "MARKET",
  [NFLCompetition.commonDataSource.type]: "TEMPLATE",
  [NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "MARKET",
  [NFLCompetition.stages["LIVE" /* LIVE */].type]: "MARKET",
  [NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type]: "MARKET",
  [NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "MARKET",
  [NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "MARKET",
  [nascarCompetition.commonDataSource.type]: "TEMPLATE",
  [nascarCompetition.stages[NascarStages.COUNTDOWN].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.LIVE].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.POST].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.QUALIFICATION].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.DELAY].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.FASTEST_LAP].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.STAGE_WINNER].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.RACE_WINNER].type]: "MARKET",
  [nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type]: "MARKET",
  [typeName28]: "TEMPLATE"
};
var friendlyNameFromSourceTypeMap = {
  [NBACompetition.commonDataSource.type]: "NBA",
  [NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "Pre-event",
  [NBACompetition.stages["LIVE" /* LIVE */].type]: "Live",
  [NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "Post-event",
  [SoccerCompetition.commonDataSource.type]: "Soccer",
  [SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "Pre-event",
  [SoccerCompetition.stages["LIVE" /* LIVE */].type]: "Live",
  [SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type]: "Live Goal",
  [SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "Post-event",
  [SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "Post Winner",
  [NFLCompetition.commonDataSource.type]: "American Football (NFL)",
  [NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "Pre-event",
  [NFLCompetition.stages["LIVE" /* LIVE */].type]: "Live",
  [NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type]: "Live Touchdown",
  [NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "Post-event",
  [NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "Post Winner",
  [nascarCompetition.commonDataSource.type]: "Nascar",
  [nascarCompetition.stages[NascarStages.COUNTDOWN].type]: "Countdown",
  [nascarCompetition.stages[NascarStages.LIVE].type]: "Live",
  [nascarCompetition.stages[NascarStages.POST].type]: "Post",
  [nascarCompetition.stages[NascarStages.QUALIFICATION].type]: "Qualification",
  [nascarCompetition.stages[NascarStages.DELAY].type]: "Race Delay",
  [nascarCompetition.stages[NascarStages.FASTEST_LAP].type]: "Fastest Lap",
  [nascarCompetition.stages[NascarStages.STAGE_WINNER].type]: "Stage Winner",
  [nascarCompetition.stages[NascarStages.RACE_WINNER].type]: "Race Winner",
  [nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type]: "Top 10 Finish",
  [typeName28]: "Casino"
};
var iconMap = {
  [NBACompetition.commonDataSource.type]: "LuTarget",
  [NBACompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "LuTarget",
  [NBACompetition.stages["LIVE" /* LIVE */].type]: "LuTarget",
  [NBACompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "LuTarget",
  [SoccerCompetition.commonDataSource.type]: "LuTarget",
  [SoccerCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "LuTarget",
  [SoccerCompetition.stages["LIVE" /* LIVE */].type]: "LuTarget",
  [SoccerCompetition.stages["LIVE_GOAL" /* LIVE_GOAL */].type]: "LuTarget",
  [SoccerCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "LuTarget",
  [SoccerCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "LuTarget",
  [NFLCompetition.commonDataSource.type]: "LuTarget",
  [NFLCompetition.stages["PRE_EVENT" /* PRE_EVENT */].type]: "LuTarget",
  [NFLCompetition.stages["LIVE" /* LIVE */].type]: "LuTarget",
  [NFLCompetition.stages["LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */].type]: "LuTarget",
  [NFLCompetition.stages["POST_EVENT" /* POST_EVENT */].type]: "LuTarget",
  [NFLCompetition.stages["POST_WINNER" /* POST_WINNER */].type]: "LuTarget",
  [nascarCompetition.commonDataSource.type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.COUNTDOWN].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.LIVE].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.POST].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.QUALIFICATION].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.DELAY].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.FASTEST_LAP].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.STAGE_WINNER].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.RACE_WINNER].type]: "LuTarget",
  [nascarCompetition.stages[NascarStages.TOP_TEN_FINISH].type]: "LuTarget",
  [typeName28]: "LuTarget"
};
var competitions = {
  [typeName29]: NBACompetition,
  [typeName35]: SoccerCompetition,
  [typeName41]: NFLCompetition,
  [typeName24]: nascarCompetition
};
var sportsMomentsCompetitionNames = {
  NBA: typeName29,
  SOCCER: typeName35,
  NFL: typeName41
};

// src/datasources/core.ts
var sourceTypes3 = [
  ...sourceTypes,
  ...sourceTypes2
];
var dataSourcesConfigs3 = [
  ...dataSourcesConfigs,
  ...dataSourcesConfigs2
];
var sportsMomentsCompetitionNames2 = sportsMomentsCompetitionNames;
var competitions2 = competitions;
var teamImagesMappingConfigs2 = teamImagesMappingConfigs;
var combinedDP3 = [
  ...combinedDP,
  ...combinedDP2
];
var combinedTypeMap = {
  ...recommendersTypeMap,
  ...typeMap
};
var marketDataTypes2 = [
  ...recommendersMarketDataTypes,
  ...marketDataTypes
];
var normalisedMarketNames3 = {
  ...normalisedMarketNames,
  ...normalisedMarketNames2
};
var mapDataTypesFromSourceTypes3 = {
  ...mapDataTypesFromSourceTypes,
  ...mapDataTypesFromSourceTypes2
};
var friendlyNameFromSourceTypeMap2 = {
  ...recommendersFriendlyNameFromSourceTypeMap,
  ...friendlyNameFromSourceTypeMap
};
var iconMap2 = {
  ...recommendersIconMap,
  ...iconMap
};
var dataTypes = ["TEMPLATE", "MARKET", "UNKNOWN"];
var DataTypeSchema = z.enum(dataTypes);
var SourceTypeSchema = z.enum(sourceTypes3);
var newSourceTypes = sourceTypes3.filter(
  (type) => type !== typeName && type !== "UNKNOWN_FUTURE_ADDITION"
);
var dataPoints43 = dataSourcesConfigs3.map((dp) => dp.points).flat();
var textElementDataPoints = dataSourcesConfigs3.map((dp) => dp.points.filter((dp2) => dp2.type === "TEXT").map((dp2) => dp2.name)).flat();
var AllEventDataPointNameSchema = z.enum(combinedDP3);
var DataSource = class {
  name;
  id;
  dataType;
  type;
  dataPoints;
  constructor(name, dataPoints44, dataType, type, id = null) {
    this.name = name;
    this.dataPoints = dataPoints44;
    this.dataType = dataType;
    this.type = type;
    this.id = id ?? nanoid(11);
  }
  get shortenedType() {
    const typeMap2 = combinedTypeMap;
    const shortenedValue = typeMap2[this.type];
    return shortenedValue || "";
  }
  getSuggestions(type) {
    return this.dataPoints.filter((dp) => dp.type === type).map((point) => ({
      id: `${this.id}:${point.name}`,
      display: friendlyDataPointName(point.name),
      sourceName: this.name,
      sourceTypeShort: this.shortenedType
    }));
  }
};
var dataSourceDefinition = new DataSource("Event", dataPoints43, "TEMPLATE", "EVENT");
var isMarketDataType = (type) => {
  return marketDataTypes2.includes(type);
};
var sourceTypeToNormalisedMarketName = (source) => {
  if (!normalisedMarketNames3[source]) {
    throw new Error(`sourceTypeToNormalisedMarketName() - unknown source type - ${source}`);
  }
  return normalisedMarketNames3[source];
};
var availableMarketTypesForCompetition = (competitionName) => {
  const competition = competitions2[competitionName];
  if (!competition) {
    return [];
  }
  return Object.values(competition.stages).map((stage) => stage.type);
};
var createDataSourceDefinitions = (adTemplateDataSources) => {
  return dataSourcesConfigs3.map((dsc) => {
    const id = adTemplateDataSources?.find((ds) => ds.type === dsc.type)?.id || null;
    return new DataSource(dsc.name, dsc.points, dsc.dataType, dsc.type, id);
  });
};
var parseDataPointName = (maybeDataPointName, allowableDataPointNames) => {
  const dataPointName = allowableDataPointNames.find((dp) => dp === maybeDataPointName);
  if (dataPointName) {
    return dataPointName;
  }
  throw new Error("That is not a data point name.");
};
function friendlyDataPointName(str) {
  return str.split("_").map((word, i, arr) => {
    if (/^\d+$/.test(word)) {
      return i === arr.length - 1 ? toOrdinalEnSimple(parseInt(word, 10)) : word;
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
}
function getDataTypeFromSourceType(sourceType) {
  const map = mapDataTypesFromSourceTypes3;
  return map[sourceType];
}
function getFriendlySourceNameFromSourceType(sourceType) {
  const map = friendlyNameFromSourceTypeMap2;
  return map[sourceType];
}
function getIconNameForSourceType(sourceType) {
  return iconMap2[sourceType] ?? "LuXCircle";
}
function toOrdinalEnSimple(n) {
  const v = Math.abs(n) % 100;
  if (v >= 11 && v <= 13)
    return `${n}th`;
  switch (v % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

// src/element-name.ts
var CUSTOM_ASSET_BASE_URL = "https://cdn.fresh8.co/assets/operator-jerseys";
var KNOWN_IMAGE_FILE_TEMPLATE_EXT = /\.(png|jpe?g|svg|webp|gif)$/i;
var INLINE_TOKEN_PATTERN = /\{([A-Z_][A-Z0-9_]*)\}/;
var INLINE_TOKEN_REGEX = new RegExp(INLINE_TOKEN_PATTERN, "g");
var hasInlineTokens = (value) => typeof value === "string" && INLINE_TOKEN_PATTERN.test(value);
var extractInlineTokens = (value) => {
  if (typeof value !== "string" || value.length === 0)
    return [];
  return Array.from(value.matchAll(new RegExp(INLINE_TOKEN_PATTERN, "g")), (match) => match[1]);
};
var normalizeFileTemplate = (raw) => raw.replace(/\{(\w+)\}$/, (_, ext) => `.${ext.toLowerCase()}`);
var appendSvgIfExtensionlessForCreatomate = (fileTemplate) => KNOWN_IMAGE_FILE_TEMPLATE_EXT.test(fileTemplate) ? fileTemplate : `${fileTemplate}.svg`;
var parseElementName = (rawName) => {
  const pipeIndex = rawName.indexOf("|");
  if (pipeIndex === -1)
    return { name: rawName, config: null };
  const [name, config] = rawName.split("|");
  if (config?.toLowerCase() === "editable") {
    return {
      name,
      config: { isEditable: true, customAssetConfig: null }
    };
  }
  const colonIndex = config?.indexOf(":") ?? -1;
  if (colonIndex !== -1 && config) {
    const folder = config.substring(0, colonIndex);
    const fileTemplate = normalizeFileTemplate(config.substring(colonIndex + 1));
    return {
      name,
      config: {
        isEditable: false,
        customAssetConfig: { folder, fileTemplate }
      }
    };
  }
  return {
    name,
    config: { isEditable: false, customAssetConfig: null }
  };
};
var buildCustomAssetContentUrl = (config, dataPointName, sourceId) => {
  return `${CUSTOM_ASSET_BASE_URL}/${config.folder}/{${sourceId}:${dataPointName}}${config.fileTemplate}`;
};

// src/datasources/matching.ts
var getAutoImportNames = (dataPoint) => {
  const autoImportName = dataPoint.autoImportName ?? dataPoint.name;
  return Array.isArray(autoImportName) ? autoImportName : [autoImportName];
};
var elementNameMatchesAutoImport = (elementName, autoImportName) => {
  const name = elementName ?? "";
  const normalizedImportName = (autoImportName ?? "").toUpperCase();
  if (name.replace(/^\{|\}$/g, "").toUpperCase() === normalizedImportName) {
    return true;
  }
  return extractInlineTokens(name).some((token) => token.toUpperCase() === normalizedImportName);
};
var findMatchedAutoImportName = (dataPoint, elementName) => {
  if (dataPoint.autoImportName == null) {
    return null;
  }
  return getAutoImportNames(dataPoint).find((name) => elementNameMatchesAutoImport(elementName, name)) ?? null;
};

// src/datasources/import/constants.ts
var SOCCER_COMPETITION_TYPE = "SOCCER";
var SOCCER_STAGE_TYPES = new Set(
  Object.values(SoccerCompetition.stages).map((config) => config.type)
);
var SOCCER_SOURCE_TYPES = /* @__PURE__ */ new Set([
  SOCCER_COMPETITION_TYPE,
  ...SOCCER_STAGE_TYPES
]);
var NBA_COMPETITION_TYPE = "NBA";
var NBA_STAGE_TYPES = new Set(
  Object.values(NBACompetition.stages).map((config) => config.type)
);
var NBA_SOURCE_TYPES = /* @__PURE__ */ new Set([
  NBA_COMPETITION_TYPE,
  ...NBA_STAGE_TYPES
]);
var NFL_COMPETITION_TYPE = "NFL";
var NFL_STAGE_TYPES = new Set(
  Object.values(NFLCompetition.stages).map((config) => config.type)
);
var NFL_SOURCE_TYPES = /* @__PURE__ */ new Set([
  NFL_COMPETITION_TYPE,
  ...NFL_STAGE_TYPES
]);
var SPORTS_MOMENTS_SOURCE_TYPES = /* @__PURE__ */ new Set([
  ...SOCCER_SOURCE_TYPES,
  ...NBA_SOURCE_TYPES,
  ...NFL_SOURCE_TYPES
]);
var CAR_RACING_COMPETITION_TYPE = "NASCAR";
var CAR_RACING_STAGE_TYPES = new Set(
  Object.values(competitions2[CAR_RACING_COMPETITION_TYPE]?.stages ?? {}).map(
    (config) => config.type
  )
);
var CAR_RACING_SOURCE_TYPES = /* @__PURE__ */ new Set([
  CAR_RACING_COMPETITION_TYPE,
  ...CAR_RACING_STAGE_TYPES
]);
var DIRECT_COMPETITION_SOURCE_TYPES = new Set(
  Object.entries(competitions2).flatMap(([key, comp]) => [
    key,
    ...Object.values(comp.stages).map((stage) => stage.type)
  ])
);
var SPORTS_TEMPLATE_SOURCE_TYPES = /* @__PURE__ */ new Set([
  "EVENT",
  "NEW_EVENT",
  "EVENT_COMPETITOR_FOCUSED",
  "OUTRIGHT"
]);
var DEFAULT_SPORTS_TEMPLATE_TYPE = "NEW_EVENT";
var NON_SOCCER_SPORTS_SOURCE_TYPES = new Set(
  Object.entries(competitions2).filter(([key]) => key !== SOCCER_COMPETITION_TYPE).flatMap(([key, comp]) => [
    key,
    ...Object.values(comp.stages).map((s) => s.type)
  ])
);
var ALL_SOCCER_DATA_POINT_NAMES = new Set(
  dataSourcesConfigs3.filter((dsc) => SOCCER_SOURCE_TYPES.has(dsc.type)).flatMap((dsc) => dsc.points.flatMap((p) => getAutoImportNames(p)))
);
var ALL_NBA_DATA_POINT_NAMES = new Set(
  dataSourcesConfigs3.filter((dsc) => NBA_SOURCE_TYPES.has(dsc.type)).flatMap((dsc) => dsc.points.flatMap((p) => getAutoImportNames(p)))
);
var ALL_NFL_DATA_POINT_NAMES = new Set(
  dataSourcesConfigs3.filter((dsc) => NFL_SOURCE_TYPES.has(dsc.type)).flatMap((dsc) => dsc.points.flatMap((p) => getAutoImportNames(p)))
);
var OTHER_THAN_SOCCER_DATA_POINT_NAMES = /* @__PURE__ */ new Set([
  ...ALL_NBA_DATA_POINT_NAMES,
  ...ALL_NFL_DATA_POINT_NAMES
]);
var OTHER_THAN_NBA_DATA_POINT_NAMES = /* @__PURE__ */ new Set([
  ...ALL_SOCCER_DATA_POINT_NAMES,
  ...ALL_NFL_DATA_POINT_NAMES
]);
var OTHER_THAN_NFL_DATA_POINT_NAMES = /* @__PURE__ */ new Set([
  ...ALL_SOCCER_DATA_POINT_NAMES,
  ...ALL_NBA_DATA_POINT_NAMES
]);
var GENERIC_AUTO_IMPORT_NAMES = new Set(
  dataSourcesConfigs3.filter(
    (dsc) => !SPORTS_MOMENTS_SOURCE_TYPES.has(dsc.type) && !NON_SOCCER_SPORTS_SOURCE_TYPES.has(dsc.type)
  ).flatMap(
    (dsc) => dsc.points.flatMap((p) => p.autoImportName == null ? [] : getAutoImportNames(p))
  )
);
var GENERIC_SPORTS_MOMENTS_DATA_POINT_NAMES = new Set(
  dataSourcesConfigs3.filter((dsc) => SPORTS_MOMENTS_SOURCE_TYPES.has(dsc.type)).flatMap(
    (dsc) => dsc.points.filter(
      (point) => getAutoImportNames(point).some((name) => GENERIC_AUTO_IMPORT_NAMES.has(name))
    ).map((point) => point.name)
  )
);
var GENERIC_CAR_RACING_DATA_POINT_NAMES = new Set(
  dataSourcesConfigs3.filter((dsc) => CAR_RACING_SOURCE_TYPES.has(dsc.type)).flatMap(
    (dsc) => dsc.points.filter(
      (point) => getAutoImportNames(point).some(
        (name) => ALL_SOCCER_DATA_POINT_NAMES.has(name) || ALL_NBA_DATA_POINT_NAMES.has(name) || ALL_NFL_DATA_POINT_NAMES.has(name)
      )
    ).map((point) => point.name)
  )
);
var STAGE_MARKET_SOURCE_TYPES = /* @__PURE__ */ new Set([
  "FULL_TIME_RESULT",
  "MATCH_WINNER"
]);
var carRacingStageSelectOptions = Object.values(
  competitions2[CAR_RACING_COMPETITION_TYPE]?.stages ?? {}
).map((config) => ({
  value: config.type,
  label: config.name
}));

// src/datasources/suggest.ts
var toPublicSuggestion = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  matchedAutoImportName: _,
  ...publicSuggestion
}) => publicSuggestion;
var suggestDataSources = (inputElements) => {
  const isCompetitorFocused = inputElements.some((te) => isCompetitorFocusedPoint(te.name));
  const mappedDataSources = inputElements.flatMap((te) => {
    const cleanName = parseElementName(te.name).name;
    return dataSourcesConfigs3.filter((dsc) => isCompetitorFilter(dsc, isCompetitorFocused)).flatMap((config) => {
      return config.points.map((dp) => {
        const matchedAutoImportName = findMatchedAutoImportName(dp, cleanName);
        return matchedAutoImportName ? { dp, matchedAutoImportName } : false;
      }).filter(
        (match) => Boolean(match)
      ).map(
        ({ dp, matchedAutoImportName }) => ({
          elId: te.id,
          dataPointName: dp.name,
          matchedAutoImportName,
          type: config.type,
          dataType: config.dataType,
          name: config.name
        })
      );
    });
  });
  const teamImagesDataSources = inputElements.flatMap((te) => {
    const cleanName = parseElementName(te.name).name;
    return teamImagesMappingConfigs2.filter((config) => config.autoImportName === cleanName).map(
      (config) => ({
        elId: te.id,
        dataPointName: config.name,
        matchedAutoImportName: config.autoImportName,
        type: config.type,
        dataType: config.dataType,
        name: config.name
      })
    );
  });
  const flat = [...mappedDataSources, ...teamImagesDataSources];
  const templateTypes = new Set(
    flat.filter((item) => item.dataType === "TEMPLATE").map((v) => v.type)
  );
  let filtered = flat;
  if (templateTypes.size > 1) {
    filtered = flat.filter((item) => {
      if (item.dataType !== "TEMPLATE")
        return true;
      return item.type !== typeName && item.type !== typeName4;
    });
  }
  filtered = applyCountdownFilter(filtered);
  filtered = filterWeakSportsMomentsTemplateSuggestions(filtered);
  const byType = filtered.reduce((acc, curr) => {
    if (!acc[curr.type]) {
      acc[curr.type] = [];
    }
    acc[curr.type].push(toPublicSuggestion(curr));
    return acc;
  }, {});
  return Object.values(byType).filter((v) => v.length > 0).sort((a, b) => a[0].type.localeCompare(b[0].type));
};
var filterWeakSportsMomentsTemplateSuggestions = (suggestions) => {
  const hasGenericTemplate = suggestions.some(
    (suggestion) => suggestion.dataType === "TEMPLATE" && SPORTS_TEMPLATE_SOURCE_TYPES.has(suggestion.type)
  );
  if (!hasGenericTemplate) {
    return suggestions;
  }
  let filtered = suggestions;
  filtered = filterWeakCompetitionCommonSuggestions(
    filtered,
    SOCCER_COMPETITION_TYPE,
    SOCCER_SOURCE_TYPES
  );
  filtered = filterWeakCompetitionCommonSuggestions(
    filtered,
    NFL_COMPETITION_TYPE,
    NFL_SOURCE_TYPES
  );
  return filtered;
};
var filterWeakCompetitionCommonSuggestions = (suggestions, competitionType, competitionSourceTypes) => {
  const hasNonCommonCompetitionSignal = suggestions.some(
    (suggestion) => competitionSourceTypes.has(suggestion.type) && suggestion.type !== competitionType
  );
  if (hasNonCommonCompetitionSignal) {
    return suggestions;
  }
  const commonSuggestions = suggestions.filter((suggestion) => suggestion.type === competitionType);
  const hasExclusiveCommonSuggestion = commonSuggestions.some((suggestion) => {
    return !GENERIC_AUTO_IMPORT_NAMES.has(suggestion.matchedAutoImportName);
  });
  if (hasExclusiveCommonSuggestion) {
    return suggestions;
  }
  return suggestions.filter((suggestion) => suggestion.type !== competitionType);
};
var applyCountdownFilter = (suggestions) => {
  const byType = suggestions.reduce((acc, curr) => {
    if (!acc[curr.type])
      acc[curr.type] = [];
    acc[curr.type].push(curr);
    return acc;
  }, {});
  let filtered = [];
  for (const [type, items] of Object.entries(byType)) {
    const hasCountdown = items.some(
      (s) => ["COUNTDOWN", "PRE_COUNTDOWN"].includes(s.dataPointName)
    );
    const hasOther = items.some((s) => !["COUNTDOWN", "PRE_COUNTDOWN"].includes(s.dataPointName));
    const isSportsMomentsType = SPORTS_MOMENTS_SOURCE_TYPES.has(type);
    const templateCountdownOnlyNoise = items[0]?.dataType === "TEMPLATE" && hasCountdown && !hasOther && !isSportsMomentsType;
    if (templateCountdownOnlyNoise) {
      filtered = filtered.concat(
        items.filter((s) => !["COUNTDOWN", "PRE_COUNTDOWN"].includes(s.dataPointName))
      );
    } else {
      filtered = filtered.concat(items);
    }
  }
  return filtered;
};

// src/datasources/resolve-tokens.ts
var resolveTokenToDataPoint = (token, dataSources) => {
  for (const dataSource of dataSources) {
    const config = dataSourcesConfigs3.find((c) => c.type === dataSource.type);
    if (!config)
      continue;
    for (const point of config.points) {
      if (point.autoImportName == null)
        continue;
      const names = Array.isArray(point.autoImportName) ? point.autoImportName : [point.autoImportName];
      if (names.some((n) => elementNameMatchesAutoImport(token, n))) {
        return {
          sourceId: dataSource.id,
          dataPointName: point.name
        };
      }
    }
  }
  return null;
};
var resolveLayerNameToDataPoint = (rawName, dataSources) => {
  const cleanName = parseElementName(rawName ?? "").name.trim();
  const token = cleanName.replace(/(^\{)|(\}$)/g, "");
  if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(token))
    return null;
  const match = resolveTokenToDataPoint(token, dataSources);
  if (!match)
    return null;
  const ds = dataSources.find((d) => d.id === match.sourceId);
  if (!ds)
    return null;
  return {
    sourceId: match.sourceId,
    dataPointName: match.dataPointName,
    sourceType: ds.type
  };
};
var resolveInlineTokensInContent = (content, dataSources) => {
  const sources = [];
  const sourceTypes4 = /* @__PURE__ */ new Set();
  const newContent = content.replace(INLINE_TOKEN_REGEX, (raw, token) => {
    const match = resolveTokenToDataPoint(token, dataSources);
    if (!match)
      return raw;
    const isDuplicateSource = sources.some(
      (s) => s.sourceId === match.sourceId && s.name === match.dataPointName
    );
    if (!isDuplicateSource) {
      sources.push({ sourceId: match.sourceId, name: match.dataPointName });
    }
    const ds = dataSources.find((d) => d.id === match.sourceId);
    if (ds)
      sourceTypes4.add(ds.type);
    return `{${match.sourceId}:${match.dataPointName}}`;
  });
  return { content: newContent, sources, sourceTypes: Array.from(sourceTypes4) };
};
var mergeTextElementSources = (base, extras) => {
  const merged = [...base ?? []];
  for (const s of extras) {
    if (!merged.some((m) => m.sourceId === s.sourceId && m.name === s.name)) {
      merged.push(s);
    }
  }
  return merged;
};
var resolveTextElementTokens = (textEl, dataSources) => {
  if (hasInlineTokens(textEl.data?.content)) {
    const { content, sources, sourceTypes: sourceTypes4 } = resolveInlineTokensInContent(
      textEl.data.content,
      dataSources
    );
    return {
      element: {
        ...textEl,
        data: { ...textEl.data, content },
        sources: mergeTextElementSources(textEl.sources, sources)
      },
      sourceTypes: sourceTypes4
    };
  }
  const nameMatch = resolveLayerNameToDataPoint(textEl.name, dataSources);
  if (!nameMatch)
    return null;
  return {
    element: {
      ...textEl,
      data: {
        ...textEl.data,
        content: `{${nameMatch.sourceId}:${nameMatch.dataPointName}}`
      },
      sources: mergeTextElementSources(textEl.sources, [
        { sourceId: nameMatch.sourceId, name: nameMatch.dataPointName }
      ])
    },
    sourceTypes: [nameMatch.sourceType]
  };
};

// src/datasources/import/stage-matchers.ts
var soccerStageTypeToStage = new Map(
  Object.entries(SoccerCompetition.stages).map(([stage, config]) => [
    config.type,
    stage
  ])
);
var nbaStageTypeToStage = new Map(
  Object.entries(NBACompetition.stages).map(([stage, config]) => [config.type, stage])
);
var nflStageTypeToStage = new Map(
  Object.entries(NFLCompetition.stages).map(([stage, config]) => [config.type, stage])
);
var soccerStageToSourceType = (stage) => {
  return SoccerCompetition.stages[stage].type;
};
var nbaStageToSourceType = (stage) => {
  return NBACompetition.stages[stage].type;
};
var nflStageToSourceType = (stage) => {
  return NFLCompetition.stages[stage].type;
};
var nascarStageToSourceType = (stage) => {
  return nascarCompetition.stages[stage].type;
};
var NASCAR_OPTION_GRID_DATA_POINT_NAMES = new Set(
  nascarCompetition.stages[NascarStages.LIVE].points.map((point) => point.name)
);
function getMatchedNascarStages(dataPointNames43) {
  const has = (name) => dataPointNames43.has(name);
  const exclusive = [];
  if (has("MOMENT_FASTEST_LAP") || has("MOMENT_FASTEST_LAP_TIME")) {
    exclusive.push(NascarStages.FASTEST_LAP);
  }
  if (has("MOMENT_STAGE_NUMBER") || has("MOMENT_STAGE_LAPS_TOTAL") || has("MOMENT_STAGE_LAPS_COMPLETED")) {
    exclusive.push(NascarStages.STAGE_WINNER);
  }
  if (exclusive.length > 0) {
    return exclusive;
  }
  if (has("MOMENT_POSITION")) {
    return [NascarStages.RACE_WINNER, NascarStages.TOP_TEN_FINISH];
  }
  if (has("MOMENT_DRIVER_NAME") || has("MOMENT_DRIVER_NUMBER") || has("MOMENT_DRIVER_CUSTOM") || has("MOMENT_CAR_TEAM_NAME")) {
    return [
      NascarStages.STAGE_WINNER,
      NascarStages.FASTEST_LAP,
      NascarStages.RACE_WINNER,
      NascarStages.TOP_TEN_FINISH
    ];
  }
  if (has("COUNTDOWN") || has("RACE_NAME")) {
    return [NascarStages.COUNTDOWN];
  }
  if ([...dataPointNames43].some((name) => NASCAR_OPTION_GRID_DATA_POINT_NAMES.has(name))) {
    return [NascarStages.QUALIFICATION, NascarStages.LIVE, NascarStages.POST];
  }
  return [];
}
function getMatchedSoccerStages(dataPointNames43) {
  const matched = [];
  const has = (name) => dataPointNames43.has(name);
  if (has("POST_WINNER_TEAM_NAME") || has("POST_WINNER_TEAM_COMPETITOR_ID")) {
    matched.push("POST_WINNER" /* POST_WINNER */);
  }
  if (has("MOMENT_GOAL_SCORER_NAME") || has("MOMENT_GOAL_MATCH_TIME") || has("MOMENT_GOAL_TEAM_COMPETITOR_ID")) {
    matched.push("LIVE_GOAL" /* LIVE_GOAL */);
  }
  if ((has("POST_TEAM_HOME_SCORE") || has("POST_TEAM_AWAY_SCORE") || has("POST_EVENT_OUTCOME")) && !has("POST_WINNER_TEAM_NAME") && !has("POST_WINNER_TEAM_COMPETITOR_ID")) {
    matched.push("POST_EVENT" /* POST_EVENT */);
  }
  if ((has("LIVE_TEAM_HOME_SCORE") || has("LIVE_TEAM_AWAY_SCORE")) && !has("MOMENT_GOAL_SCORER_NAME") && !has("MOMENT_GOAL_MATCH_TIME") && !has("MOMENT_GOAL_TEAM_COMPETITOR_ID")) {
    matched.push("LIVE" /* LIVE */);
  }
  if (has("COUNTDOWN") && !has("LIVE_TEAM_HOME_SCORE") && !has("POST_TEAM_HOME_SCORE")) {
    matched.push("PRE_EVENT" /* PRE_EVENT */);
  }
  return matched;
}
function getMatchedNFLStages(dataPointNames43) {
  const matched = [];
  const has = (name) => dataPointNames43.has(name);
  if (has("POST_WINNER_TEAM_NAME") || has("POST_WINNER_TEAM_MARKET") || has("POST_WINNER_TEAM_COMPETITOR_ID")) {
    matched.push("POST_WINNER" /* POST_WINNER */);
  }
  if (has("MOMENT_TOUCHDOWN_SCORER_NAME") || has("MOMENT_TOUCHDOWN_TEAM_NAME") || has("MOMENT_TOUCHDOWN_TEAM_MARKET") || has("MOMENT_TOUCHDOWN_TEAM_SR_ID") || has("MOMENT_TOUCHDOWN_SCORER_SR_ID")) {
    matched.push("LIVE_TOUCHDOWN" /* LIVE_TOUCHDOWN */);
  }
  if ((has("POST_TEAM_HOME_SCORE") || has("POST_TEAM_AWAY_SCORE") || has("POST_EVENT_OUTCOME")) && !has("POST_WINNER_TEAM_NAME") && !has("POST_WINNER_TEAM_MARKET") && !has("POST_WINNER_TEAM_COMPETITOR_ID")) {
    matched.push("POST_EVENT" /* POST_EVENT */);
  }
  if ((has("LIVE_TEAM_HOME_SCORE") || has("LIVE_TEAM_AWAY_SCORE") || has("LIVE_MATCH_TIME") || has("LIVE_MATCH_QUARTER")) && !has("MOMENT_TOUCHDOWN_SCORER_NAME") && !has("MOMENT_TOUCHDOWN_TEAM_NAME") && !has("MOMENT_TOUCHDOWN_TEAM_MARKET") && !has("MOMENT_TOUCHDOWN_TEAM_SR_ID") && !has("MOMENT_TOUCHDOWN_SCORER_SR_ID")) {
    matched.push("LIVE" /* LIVE */);
  }
  if ((has("COUNTDOWN") || has("INSIGHTS_SHORT")) && !has("LIVE_TEAM_HOME_SCORE") && !has("LIVE_MATCH_QUARTER") && !has("POST_TEAM_HOME_SCORE")) {
    matched.push("PRE_EVENT" /* PRE_EVENT */);
  }
  return matched;
}

// src/datasources/import/infer.ts
function detectSuggestedMarket(suggestions) {
  const marketGroup = suggestions.find(
    (group) => group.length > 0 && STAGE_MARKET_SOURCE_TYPES.has(group[0].type)
  );
  return marketGroup ? marketGroup[0].type : null;
}
function uniqueSourceTypes(types) {
  return [...new Set(types.filter((type) => type != null))];
}
function getSuggestionTypes(suggestions) {
  return uniqueSourceTypes(suggestions.map((group) => group[0]?.type));
}
function isGenericSportsMarketSourceType(type) {
  return isMarketDataType(type) && !DIRECT_COMPETITION_SOURCE_TYPES.has(type);
}
function getGenericSportsTemplateType(suggestions) {
  const templateTypes = getSuggestionTypes(suggestions).filter(
    (type) => SPORTS_TEMPLATE_SOURCE_TYPES.has(type)
  );
  if (templateTypes.includes(DEFAULT_SPORTS_TEMPLATE_TYPE)) {
    return DEFAULT_SPORTS_TEMPLATE_TYPE;
  }
  return templateTypes[0] ?? null;
}
function getGenericSportsMarketTypes(suggestions) {
  return getSuggestionTypes(suggestions).filter(isGenericSportsMarketSourceType);
}
function getSuggestionGroupsForTypes(suggestions, sourceTypes4) {
  return suggestions.filter((group) => group.length > 0 && sourceTypes4.has(group[0].type));
}
function hasNonGenericSportsMomentsSignal(suggestions) {
  return suggestions.some(
    (group) => group.some(
      (suggestion) => (
        // Alias-only false positives such as HOME_CUSTOM/AWAY_CUSTOM on SOCCER common are
        // removed before suggestions are converted into this public plain-object shape.
        !GENERIC_SPORTS_MOMENTS_DATA_POINT_NAMES.has(suggestion.dataPointName)
      )
    )
  );
}
function hasCompetitionExclusiveSignal(suggestions, otherCompetitionDataPointNames) {
  return suggestions.some(
    (group) => group.some((suggestion) => !otherCompetitionDataPointNames.has(suggestion.dataPointName))
  );
}
function getImportDataSourceCompetitionLabel(competition) {
  switch (competition) {
    case "SOCCER":
      return SoccerCompetition.commonDataSource.name;
    case "NBA":
      return NBACompetition.commonDataSource.name;
    case "NFL":
      return NFLCompetition.commonDataSource.name;
    case "NASCAR":
      return competitions2[CAR_RACING_COMPETITION_TYPE]?.commonDataSource.name ?? "Nascar";
    case null:
      return "Choose competition";
  }
}
function getImportDataSourceCompetitionFieldLabel(sourceFamily) {
  return sourceFamily === "SPORTS_MOMENTS" ? "Sport" : "Competition";
}
function getImportDataSourceCompetitionPlaceholderLabel(sourceFamily) {
  return sourceFamily === "SPORTS_MOMENTS" ? "Choose sport" : "Choose competition";
}
function getImportDataSourceCompetitionOptions() {
  const competitions3 = ["SOCCER", "NBA", "NFL"];
  return competitions3.map((competition) => ({
    value: competition,
    label: getImportDataSourceCompetitionLabel(competition)
  }));
}
function getSportsMomentsCommonSourceType(competition) {
  switch (competition) {
    case "SOCCER":
      return SOCCER_COMPETITION_TYPE;
    case "NBA":
      return NBA_COMPETITION_TYPE;
    case "NFL":
      return NFL_COMPETITION_TYPE;
  }
}
function getSportsMomentsStageTypes(competition) {
  switch (competition) {
    case "SOCCER":
      return SOCCER_STAGE_TYPES;
    case "NBA":
      return NBA_STAGE_TYPES;
    case "NFL":
      return NFL_STAGE_TYPES;
  }
}
function getSportsMomentsStageOptions(competition) {
  if (competition === "SOCCER") {
    return Object.values(SoccerCompetition.stages).map((config) => ({
      value: config.type,
      label: config.name
    }));
  }
  if (competition === "NBA") {
    return Object.values(NBACompetition.stages).map((config) => ({
      value: config.type,
      label: config.name
    }));
  }
  if (competition === "NFL") {
    return Object.values(NFLCompetition.stages).map((config) => ({
      value: config.type,
      label: config.name
    }));
  }
  return [];
}
function getSuggestedSportsMomentsCompetition(suggestions) {
  const soccerSuggestions = getSuggestionGroupsForTypes(suggestions, SOCCER_SOURCE_TYPES);
  const nbaSuggestions = getSuggestionGroupsForTypes(suggestions, NBA_SOURCE_TYPES);
  const nflSuggestions = getSuggestionGroupsForTypes(suggestions, NFL_SOURCE_TYPES);
  const signals = [
    {
      competition: "SOCCER",
      hasSignal: hasCompetitionExclusiveSignal(
        soccerSuggestions,
        OTHER_THAN_SOCCER_DATA_POINT_NAMES
      )
    },
    {
      competition: "NBA",
      hasSignal: hasCompetitionExclusiveSignal(nbaSuggestions, OTHER_THAN_NBA_DATA_POINT_NAMES)
    },
    {
      competition: "NFL",
      hasSignal: hasCompetitionExclusiveSignal(nflSuggestions, OTHER_THAN_NFL_DATA_POINT_NAMES)
    }
  ];
  const matched = signals.filter((s) => s.hasSignal);
  if (matched.length !== 1) {
    return null;
  }
  return matched[0].competition;
}
function getManualSportsMomentsImportDataSourceConfig(suggestions, competitionOverride = null) {
  const availableCompetitions = getImportDataSourceCompetitionOptions().map(
    (option) => option.value
  );
  const competition = (competitionOverride && availableCompetitions.includes(competitionOverride) ? competitionOverride : null) ?? (availableCompetitions.length === 1 ? availableCompetitions[0] : getSuggestedSportsMomentsCompetition(suggestions));
  if (competition == null) {
    return {
      sourceFamily: "SPORTS_MOMENTS",
      competition: null,
      stage: null,
      marketType: null,
      needsUserConfirmation: true
    };
  }
  const stageTypes = uniqueSourceTypes(
    getSuggestionTypes(suggestions).filter(
      (type) => getSportsMomentsStageTypes(competition).has(type)
    )
  );
  const stage = stageTypes.length === 1 ? stageTypes[0] : null;
  return {
    sourceFamily: "SPORTS_MOMENTS",
    competition,
    stage,
    marketType: competition === "SOCCER" || competition === "NFL" ? detectSuggestedMarket(suggestions) : null,
    needsUserConfirmation: stage == null
  };
}
function getSoccerStageSourceType(stage) {
  return stage == null ? null : soccerStageToSourceType(stage);
}
function getNBAStageSourceType(stage) {
  return stage == null ? null : nbaStageToSourceType(stage);
}
function getNFLStageSourceType(stage) {
  return stage == null ? null : nflStageToSourceType(stage);
}
function inferSoccerMomentsConfig(suggestions) {
  const soccerSuggestions = getSuggestionGroupsForTypes(suggestions, SOCCER_SOURCE_TYPES);
  if (soccerSuggestions.length === 0) {
    return null;
  }
  const hasExclusiveSoccerField = hasNonGenericSportsMomentsSignal(soccerSuggestions);
  if (!hasExclusiveSoccerField) {
    return null;
  }
  const nbaSuggestions = getSuggestionGroupsForTypes(suggestions, NBA_SOURCE_TYPES);
  const nflSuggestions = getSuggestionGroupsForTypes(suggestions, NFL_SOURCE_TYPES);
  const soccerHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    soccerSuggestions,
    OTHER_THAN_SOCCER_DATA_POINT_NAMES
  );
  const nbaHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nbaSuggestions,
    OTHER_THAN_NBA_DATA_POINT_NAMES
  );
  const nflHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nflSuggestions,
    OTHER_THAN_NFL_DATA_POINT_NAMES
  );
  if ((nbaHasCompetitionExclusiveField || nflHasCompetitionExclusiveField) && !soccerHasCompetitionExclusiveField) {
    return null;
  }
  const dataPointNames43 = new Set(
    soccerSuggestions.flatMap((group) => group.map((s) => s.dataPointName))
  );
  const matchedStages = getMatchedSoccerStages(dataPointNames43);
  const stage = matchedStages.length === 1 ? matchedStages[0] : null;
  const suggestedMarket = detectSuggestedMarket(suggestions);
  return {
    sourceFamily: "SPORTS_MOMENTS",
    sport: "SOCCER",
    stage,
    stageType: getSoccerStageSourceType(stage),
    suggestedMarket,
    marketType: suggestedMarket,
    needsUserConfirmation: stage == null
  };
}
function inferNBAMomentsConfig(suggestions) {
  const nbaSuggestions = getSuggestionGroupsForTypes(suggestions, NBA_SOURCE_TYPES);
  if (nbaSuggestions.length === 0) {
    return null;
  }
  const hasExclusiveNBAField = hasNonGenericSportsMomentsSignal(nbaSuggestions);
  if (!hasExclusiveNBAField) {
    return null;
  }
  const soccerSuggestions = getSuggestionGroupsForTypes(suggestions, SOCCER_SOURCE_TYPES);
  const nflSuggestions = getSuggestionGroupsForTypes(suggestions, NFL_SOURCE_TYPES);
  const nbaHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nbaSuggestions,
    OTHER_THAN_NBA_DATA_POINT_NAMES
  );
  const soccerHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    soccerSuggestions,
    OTHER_THAN_SOCCER_DATA_POINT_NAMES
  );
  const nflHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nflSuggestions,
    OTHER_THAN_NFL_DATA_POINT_NAMES
  );
  if ((soccerHasCompetitionExclusiveField || nflHasCompetitionExclusiveField) && !nbaHasCompetitionExclusiveField) {
    return null;
  }
  const stageTypes = uniqueSourceTypes(
    getSuggestionTypes(nbaSuggestions).filter((type) => NBA_STAGE_TYPES.has(type))
  );
  const stage = stageTypes.length === 1 ? nbaStageTypeToStage.get(stageTypes[0]) ?? null : null;
  return {
    sourceFamily: "SPORTS_MOMENTS",
    sport: "NBA",
    stage,
    stageType: getNBAStageSourceType(stage),
    needsUserConfirmation: stage == null
  };
}
function inferNFLMomentsConfig(suggestions) {
  const nflSuggestions = getSuggestionGroupsForTypes(suggestions, NFL_SOURCE_TYPES);
  if (nflSuggestions.length === 0) {
    return null;
  }
  const hasExclusiveNFLField = hasNonGenericSportsMomentsSignal(nflSuggestions);
  if (!hasExclusiveNFLField) {
    return null;
  }
  const soccerSuggestions = getSuggestionGroupsForTypes(suggestions, SOCCER_SOURCE_TYPES);
  const nbaSuggestions = getSuggestionGroupsForTypes(suggestions, NBA_SOURCE_TYPES);
  const nflHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nflSuggestions,
    OTHER_THAN_NFL_DATA_POINT_NAMES
  );
  const soccerHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    soccerSuggestions,
    OTHER_THAN_SOCCER_DATA_POINT_NAMES
  );
  const nbaHasCompetitionExclusiveField = hasCompetitionExclusiveSignal(
    nbaSuggestions,
    OTHER_THAN_NBA_DATA_POINT_NAMES
  );
  if ((soccerHasCompetitionExclusiveField || nbaHasCompetitionExclusiveField) && !nflHasCompetitionExclusiveField) {
    return null;
  }
  const dataPointNames43 = new Set(
    nflSuggestions.flatMap((group) => group.map((s) => s.dataPointName))
  );
  const matchedStages = getMatchedNFLStages(dataPointNames43);
  const stage = matchedStages.length === 1 ? matchedStages[0] : null;
  const suggestedMarket = detectSuggestedMarket(suggestions);
  return {
    sourceFamily: "SPORTS_MOMENTS",
    sport: "NFL",
    stage,
    stageType: getNFLStageSourceType(stage),
    suggestedMarket,
    marketType: suggestedMarket,
    needsUserConfirmation: stage == null
  };
}
function hasNonGenericCarRacingSignal(suggestions) {
  return suggestions.some(
    (group) => group.some((suggestion) => !GENERIC_CAR_RACING_DATA_POINT_NAMES.has(suggestion.dataPointName))
  );
}
function inferCarRacingImportConfig(suggestions) {
  const carRacingSuggestions = getSuggestionGroupsForTypes(suggestions, CAR_RACING_SOURCE_TYPES);
  if (carRacingSuggestions.length === 0) {
    return null;
  }
  if (!hasNonGenericCarRacingSignal(carRacingSuggestions)) {
    return null;
  }
  const dataPointNames43 = new Set(
    carRacingSuggestions.flatMap((group) => group.map((suggestion) => suggestion.dataPointName))
  );
  const matchedStages = getMatchedNascarStages(dataPointNames43);
  const stage = matchedStages.length === 1 ? nascarStageToSourceType(matchedStages[0]) : null;
  return {
    sourceFamily: "CAR_RACING",
    competition: "NASCAR",
    stage,
    needsUserConfirmation: stage == null
  };
}
function inferSportsImportConfig(suggestions) {
  const templateType = getGenericSportsTemplateType(suggestions);
  const marketTypes = getGenericSportsMarketTypes(suggestions);
  if (templateType == null && marketTypes.length === 0) {
    return null;
  }
  return {
    sourceFamily: "SPORTS",
    templateType: templateType ?? DEFAULT_SPORTS_TEMPLATE_TYPE,
    marketType: marketTypes.length === 1 ? marketTypes[0] : null,
    needsUserConfirmation: marketTypes.length > 1
  };
}
function inferImportDataSourceConfig(suggestions) {
  const soccerConfig = inferSoccerMomentsConfig(suggestions);
  const nbaConfig = inferNBAMomentsConfig(suggestions);
  const nflConfig = inferNFLMomentsConfig(suggestions);
  const sportsMomentsConfigs = [soccerConfig, nbaConfig, nflConfig].filter(Boolean);
  if (sportsMomentsConfigs.length > 1) {
    return {
      sourceFamily: "SPORTS_MOMENTS",
      competition: null,
      stage: null,
      marketType: null,
      needsUserConfirmation: true
    };
  }
  if (soccerConfig) {
    return {
      sourceFamily: "SPORTS_MOMENTS",
      competition: "SOCCER",
      stage: soccerConfig.stageType,
      marketType: soccerConfig.marketType,
      needsUserConfirmation: soccerConfig.needsUserConfirmation
    };
  }
  if (nbaConfig) {
    return {
      sourceFamily: "SPORTS_MOMENTS",
      competition: "NBA",
      stage: nbaConfig.stageType,
      marketType: null,
      needsUserConfirmation: nbaConfig.needsUserConfirmation
    };
  }
  if (nflConfig) {
    return {
      sourceFamily: "SPORTS_MOMENTS",
      competition: "NFL",
      stage: nflConfig.stageType,
      marketType: nflConfig.marketType,
      needsUserConfirmation: nflConfig.needsUserConfirmation
    };
  }
  const carRacingConfig = inferCarRacingImportConfig(suggestions);
  if (carRacingConfig) {
    return carRacingConfig;
  }
  return inferSportsImportConfig(suggestions);
}
function getImportDataSourceFamilyLabel(sourceFamily) {
  switch (sourceFamily) {
    case "SPORTS":
      return "Sports";
    case "SPORTS_MOMENTS":
      return "Sports Moments";
    case "CAR_RACING":
      return "Car Racing";
  }
}
function getImportDataSourceFamilyOptions(suggestions) {
  if (suggestions.length === 0) {
    return [];
  }
  const families = ["SPORTS", "SPORTS_MOMENTS", "CAR_RACING"];
  return families.map((family) => ({
    value: family,
    label: getImportDataSourceFamilyLabel(family)
  }));
}
function getManualImportDataSourceConfig(sourceFamily, suggestions, competitionOverride = null) {
  if (sourceFamily === "SPORTS") {
    const marketTypes = getGenericSportsMarketTypes(suggestions);
    return {
      sourceFamily: "SPORTS",
      templateType: getGenericSportsTemplateType(suggestions) ?? DEFAULT_SPORTS_TEMPLATE_TYPE,
      marketType: marketTypes.length === 1 ? marketTypes[0] : null,
      needsUserConfirmation: marketTypes.length > 1
    };
  }
  if (sourceFamily === "SPORTS_MOMENTS") {
    return getManualSportsMomentsImportDataSourceConfig(suggestions, competitionOverride);
  }
  const stageTypes = uniqueSourceTypes(
    getSuggestionTypes(suggestions).filter((type) => CAR_RACING_STAGE_TYPES.has(type))
  );
  const stage = stageTypes.length === 1 ? stageTypes[0] : null;
  return {
    sourceFamily: "CAR_RACING",
    competition: "NASCAR",
    stage,
    needsUserConfirmation: stage == null
  };
}
function resolveImportDataSourceConfig(inferredConfig, overrides = {}, suggestions = []) {
  if (inferredConfig) {
    if (inferredConfig.sourceFamily === "SPORTS_MOMENTS" && overrides.competition != null && overrides.competition !== inferredConfig.competition) {
      return getManualImportDataSourceConfig("SPORTS_MOMENTS", suggestions, overrides.competition);
    }
    return inferredConfig;
  }
  const sourceFamily = overrides.sourceFamily;
  if (!sourceFamily) {
    return null;
  }
  const availableFamilies = getImportDataSourceFamilyOptions(suggestions);
  if (!availableFamilies.some((option) => option.value === sourceFamily)) {
    return null;
  }
  return getManualImportDataSourceConfig(sourceFamily, suggestions, overrides.competition ?? null);
}

// src/datasources/import/filters.ts
function buildImportDataSourceTypes(inferredConfig, overrides = {}, suggestions = []) {
  const suggestionTypes = getSuggestionTypes(suggestions);
  if (!inferredConfig) {
    return suggestionTypes;
  }
  if (inferredConfig.sourceFamily === "SPORTS") {
    const marketTypes = getGenericSportsMarketTypes(suggestions);
    const templateType = overrides.templateType ?? inferredConfig.templateType ?? getGenericSportsTemplateType(suggestions) ?? DEFAULT_SPORTS_TEMPLATE_TYPE;
    const marketType = overrides.marketType ?? inferredConfig.marketType;
    return uniqueSourceTypes([templateType, ...marketTypes, marketType]);
  }
  if (inferredConfig.sourceFamily === "SPORTS_MOMENTS") {
    const competition = overrides.competition ?? inferredConfig.competition;
    if (competition == null) {
      return [];
    }
    const stage2 = overrides.stage ?? inferredConfig.stage;
    const marketType = overrides.marketType ?? inferredConfig.marketType;
    return uniqueSourceTypes([getSportsMomentsCommonSourceType(competition), stage2, marketType]);
  }
  const stage = overrides.stage ?? inferredConfig.stage;
  return uniqueSourceTypes([CAR_RACING_COMPETITION_TYPE, stage]);
}
function pickSuggestionGroupForElementImport(matchingGroups, elId, importSourceTypes) {
  const groupsForEl = matchingGroups.filter((g) => g.some((s) => s.elId === elId));
  if (groupsForEl.length === 0)
    return void 0;
  const allowed = new Set(importSourceTypes);
  if (allowed.size > 0) {
    const preferred = groupsForEl.filter((g) => {
      const t = g[0]?.type;
      return t != null && allowed.has(t);
    });
    if (preferred.length > 0) {
      return [...preferred].sort(
        (a, b) => String(a[0]?.type ?? "").localeCompare(String(b[0]?.type ?? ""))
      )[0];
    }
  }
  return [...groupsForEl].sort(
    (a, b) => String(a[0]?.type ?? "").localeCompare(String(b[0]?.type ?? ""))
  )[0];
}
function filterImportDataSourceSuggestions(suggestions, inferredConfig, overrides = {}) {
  if (!inferredConfig) {
    return suggestions;
  }
  if (inferredConfig.sourceFamily === "SPORTS") {
    return suggestions.filter((group) => {
      const type = group[0]?.type;
      if (type == null)
        return true;
      return !DIRECT_COMPETITION_SOURCE_TYPES.has(type);
    });
  }
  if (inferredConfig.sourceFamily === "SPORTS_MOMENTS") {
    const competition = overrides.competition ?? inferredConfig.competition;
    const stageType2 = overrides.stage ?? inferredConfig.stage;
    if (competition === "SOCCER") {
      let filtered2 = filterNonSoccerSportsSuggestions(suggestions);
      filtered2 = filterNonSoccerTemplates(filtered2);
      if (stageType2 != null) {
        const soccerStage = soccerStageTypeToStage.get(stageType2);
        return soccerStage ? filterToSoccerStage(filtered2, soccerStage) : filtered2;
      }
      return filterToSoccerCommonOnly(filtered2);
    }
    if (competition === "NBA") {
      let filtered2 = filterOtherSportsMomentsSuggestions(suggestions, "NBA");
      filtered2 = filterNonSportsMomentsTemplates(filtered2);
      if (stageType2 != null) {
        const nbaStage = nbaStageTypeToStage.get(stageType2);
        return nbaStage ? filterToNBAStage(filtered2, nbaStage) : filtered2;
      }
      return filterToNBACommonOnly(filtered2);
    }
    if (competition === "NFL") {
      let filtered2 = filterOtherSportsMomentsSuggestions(suggestions, "NFL");
      filtered2 = filterNonSportsMomentsTemplates(filtered2);
      if (stageType2 != null) {
        const nflStage = nflStageTypeToStage.get(stageType2);
        return nflStage ? filterToNFLStage(filtered2, nflStage) : filtered2;
      }
      return filterToNFLCommonOnly(filtered2);
    }
    let filtered = suggestions.filter((group) => {
      const type = group[0]?.type;
      if (type == null)
        return true;
      return !CAR_RACING_SOURCE_TYPES.has(type);
    });
    filtered = filterNonSportsMomentsTemplates(filtered);
    return filtered;
  }
  const stageType = overrides.stage ?? inferredConfig.stage;
  return suggestions.filter((group) => {
    const type = group[0]?.type;
    if (type == null)
      return true;
    if (!CAR_RACING_SOURCE_TYPES.has(type))
      return false;
    if (type === CAR_RACING_COMPETITION_TYPE)
      return true;
    return stageType == null || type === stageType;
  });
}
function filterNonSoccerSportsSuggestions(suggestions) {
  return suggestions.filter(
    (group) => group.length === 0 || !NON_SOCCER_SPORTS_SOURCE_TYPES.has(group[0].type)
  );
}
function filterOtherSportsMomentsSuggestions(suggestions, competition) {
  const allowedSourceTypes = competition === "SOCCER" ? SOCCER_SOURCE_TYPES : competition === "NBA" ? NBA_SOURCE_TYPES : NFL_SOURCE_TYPES;
  return suggestions.filter((group) => {
    const type = group[0]?.type;
    if (type == null)
      return true;
    if (allowedSourceTypes.has(type))
      return true;
    return !SPORTS_MOMENTS_SOURCE_TYPES.has(type);
  });
}
function filterToSoccerStage(suggestions, stage) {
  const allowedStageType = SoccerCompetition.stages[stage].type;
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!SOCCER_SOURCE_TYPES.has(type))
      return true;
    return type === "SOCCER" || type === allowedStageType;
  });
}
function filterNonSoccerTemplates(suggestions) {
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    if (SOCCER_SOURCE_TYPES.has(group[0].type))
      return true;
    return group[0].dataType !== "TEMPLATE";
  });
}
function filterToSoccerCommonOnly(suggestions) {
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!SOCCER_SOURCE_TYPES.has(type))
      return true;
    return type === SOCCER_COMPETITION_TYPE;
  });
}
function filterToNBAStage(suggestions, stage) {
  const allowedStageType = NBACompetition.stages[stage].type;
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!NBA_SOURCE_TYPES.has(type))
      return true;
    return type === NBA_COMPETITION_TYPE || type === allowedStageType;
  });
}
function filterToNBACommonOnly(suggestions) {
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!NBA_SOURCE_TYPES.has(type))
      return true;
    return type === NBA_COMPETITION_TYPE;
  });
}
function filterToNFLStage(suggestions, stage) {
  const allowedStageType = NFLCompetition.stages[stage].type;
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!NFL_SOURCE_TYPES.has(type))
      return true;
    return type === NFL_COMPETITION_TYPE || type === allowedStageType;
  });
}
function filterToNFLCommonOnly(suggestions) {
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    const type = group[0].type;
    if (!NFL_SOURCE_TYPES.has(type))
      return true;
    return type === NFL_COMPETITION_TYPE;
  });
}
function filterNonSportsMomentsTemplates(suggestions) {
  return suggestions.filter((group) => {
    if (group.length === 0)
      return true;
    if (SPORTS_MOMENTS_SOURCE_TYPES.has(group[0].type))
      return true;
    return group[0].dataType !== "TEMPLATE";
  });
}

// src/datasources/import/ui.ts
function getImportDataSourceStageOptions(inferredConfig) {
  if (!inferredConfig) {
    return [];
  }
  if (inferredConfig.sourceFamily === "SPORTS_MOMENTS") {
    return getSportsMomentsStageOptions(inferredConfig.competition);
  }
  if (inferredConfig.sourceFamily === "CAR_RACING") {
    return carRacingStageSelectOptions;
  }
  return [];
}
function getImportDataSourceStageLabel(inferredConfig, stage) {
  const stageOption = getImportDataSourceStageOptions(inferredConfig).find(
    (option) => option.value === stage
  );
  return stageOption?.label ?? getFriendlySourceNameFromSourceType(stage);
}
function summarizeSuggestedDataSources(suggestions) {
  const summary = /* @__PURE__ */ new Map();
  suggestions.forEach((group) => {
    const suggestion = group[0];
    if (!suggestion) {
      return;
    }
    const existing = summary.get(suggestion.name);
    if (existing) {
      existing.matchCount += group.length;
      return;
    }
    summary.set(suggestion.name, {
      label: suggestion.name,
      matchCount: group.length
    });
  });
  return [...summary.values()];
}
function getImportDataSourceDisplayDetails(inferredConfig, overrides = {}) {
  if (!inferredConfig) {
    return [];
  }
  const details = [
    {
      key: "family",
      label: "Datasource family",
      value: getImportDataSourceFamilyLabel(inferredConfig.sourceFamily)
    }
  ];
  if (inferredConfig.sourceFamily === "SPORTS") {
    if (inferredConfig.templateType) {
      details.push({
        key: "template",
        label: "Template",
        value: getFriendlySourceNameFromSourceType(inferredConfig.templateType)
      });
    }
    if (inferredConfig.marketType) {
      details.push({
        key: "market",
        label: "Market",
        value: getFriendlySourceNameFromSourceType(inferredConfig.marketType)
      });
    } else if (inferredConfig.needsUserConfirmation) {
      details.push({
        key: "market",
        label: "Market",
        value: "Multiple matches",
        isPendingSelection: true
      });
    }
    return details;
  }
  const competition = overrides.competition ?? inferredConfig.competition;
  details.push({
    key: "competition",
    label: getImportDataSourceCompetitionFieldLabel(inferredConfig.sourceFamily),
    value: competition == null ? getImportDataSourceCompetitionPlaceholderLabel(inferredConfig.sourceFamily) : getImportDataSourceCompetitionLabel(competition),
    isPendingSelection: competition == null
  });
  if (competition == null) {
    return details;
  }
  const stage = overrides.stage ?? inferredConfig.stage;
  details.push({
    key: "stage",
    label: "Stage",
    value: stage == null ? "Choose stage" : getImportDataSourceStageLabel(inferredConfig, stage),
    isPendingSelection: stage == null
  });
  if (inferredConfig.sourceFamily === "SPORTS_MOMENTS" && inferredConfig.marketType) {
    details.push({
      key: "market",
      label: "Market",
      value: getFriendlySourceNameFromSourceType(inferredConfig.marketType)
    });
  }
  return details;
}
function getImportDataSourceConfirmationMessage(inferredConfig, overrides = {}) {
  if (!inferredConfig?.needsUserConfirmation) {
    return null;
  }
  if (inferredConfig.sourceFamily === "SPORTS") {
    return "We found multiple market matches for this sports template. You can confirm the exact market after import in Configure Datasources.";
  }
  const competition = overrides.competition ?? inferredConfig.competition;
  if (competition == null) {
    return "We found matches for multiple Sports Moments competitions. Choose Soccer, Basketball (NBA), or American Football (NFL) to keep the datasource configuration.";
  }
  const stage = overrides.stage ?? inferredConfig.stage;
  if (stage == null) {
    return "We found multiple possible stage matches. Choose the correct stage now so the datasource configuration carries through to Configure Datasources.";
  }
  return null;
}

// src/utils.ts
function discriminate(discriminantKey, discriminantValue) {
  return (obj) => obj[discriminantKey] === discriminantValue;
}
function notEmpty(value) {
  return value !== null && value !== void 0;
}
function stringIsOfUnionType(str, arr) {
  return arr.find((arrItem) => arrItem === str) !== void 0;
}

// src/Recommenders/TeamAssetElement.ts
var TeamAssetElement_exports = {};
__export(TeamAssetElement_exports, {
  SportKinds: () => SportKinds,
  headGearColourSchema: () => headGearColourSchema,
  isBadgeData: () => isBadgeData,
  isKitData: () => isKitData,
  jerseyColourSchema: () => jerseyColourSchema,
  kitSchema: () => kitSchema
});
var jerseyColourSchema = z.object({
  background: z.string(),
  base: z.string().optional(),
  number: z.string().optional(),
  outline: z.string().optional(),
  sleeve: z.string().optional(),
  shirtType: z.string().optional(),
  squares: z.string().optional(),
  horizontalStripe: z.string().optional(),
  verticalStripe: z.string().optional(),
  split: z.string().optional(),
  chest: z.string().optional(),
  neck: z.string().optional()
});
var headGearColourSchema = z.object({
  background: z.string(),
  accent: z.string().optional()
});
var kitSchema = z.union([
  z.object({
    kind: z.literal("shortSleeveJersey"),
    colours: jerseyColourSchema,
    rotate: z.boolean().optional()
  }),
  z.object({
    kind: z.literal("noSleeveJersey"),
    colours: jerseyColourSchema,
    rotate: z.boolean().optional()
  }),
  z.object({
    kind: z.literal("longSleeveJersey"),
    colours: jerseyColourSchema,
    rotate: z.boolean().optional()
  }),
  z.object({
    kind: z.literal("baseballHat"),
    colours: headGearColourSchema,
    rotate: z.boolean().optional()
  }),
  z.object({
    kind: z.literal("footballHelmet"),
    colours: headGearColourSchema,
    rotate: z.boolean().optional()
  })
]);
var isBadgeData = discriminate("type", "badge");
var isKitData = discriminate("type", "kit");
var SportKinds = /* @__PURE__ */ ((SportKinds2) => {
  SportKinds2["AMERICAN_FOOTBALL_HELMET"] = "footballHelmet";
  SportKinds2["BASEBALL_HAT"] = "baseballHat";
  SportKinds2["ICE_HOCKEY_JERSEY"] = "longSleeveJersey";
  SportKinds2["FOOTBALL_JERSEY"] = "shortSleeveJersey";
  SportKinds2["BASKETBALL_JERSEY"] = "noSleeveJersey";
  SportKinds2["RUGBY_LEAGUE_JERSEY"] = "shortSleeveJersey";
  SportKinds2["RUGBY_UNION_JERSEY"] = "shortSleeveJersey";
  return SportKinds2;
})(SportKinds || {});

// src/AdflowAPI.ts
var svgTypeName = z.literal("SVG");
var textTypeName = z.literal("TEXT");
var imageTypeName = z.literal("IMAGE");
var teamAssetTypeName = z.literal("TEAM_ASSET");
var casinoAssetTypeName = z.literal("CASINO_ASSET");
var vectorTypeName = z.literal("VECTOR");
var DisplayOptionsOddsTypeSchema = z.enum([
  "europeanDecimalOdds",
  "americanOdds",
  "decimalOdds",
  "fractionalOdds",
  "impliedProbability",
  "potentialWinnings"
]);
var DisplayOptionsOddsFormatSchema = z.object({
  type: DisplayOptionsOddsTypeSchema,
  currency: z.string().optional().nullable(),
  stake: z.number().optional().nullable(),
  calculateDecimalPlaces: z.boolean().optional().nullable()
});
var AdElementTypeSchema = z.union([
  svgTypeName,
  textTypeName,
  imageTypeName,
  teamAssetTypeName,
  casinoAssetTypeName,
  vectorTypeName
]);
var AdElementDataSourceSchema = z.object({
  sourceId: z.string(),
  name: AllEventDataPointNameSchema
});
var AdElementBase = z.object({
  id: z.string(),
  name: z.string(),
  position: z.object({
    x: z.number(),
    y: z.number(),
    z: z.number().default(0)
  }),
  size: z.object({
    height: z.number(),
    width: z.number()
  }),
  rotation: z.number().optional().nullable(),
  sources: z.array(AdElementDataSourceSchema),
  type: z.union([svgTypeName, textTypeName]),
  locked: z.boolean().optional().nullable(),
  hidden: z.boolean().optional().nullable()
});
var AdElementSVGSchema = AdElementBase.extend({
  type: svgTypeName,
  data: z.object({
    svg: z.string()
  })
});
var CountdownFormatStyleSchema = z.enum([
  "digital",
  // "04:12:09"
  "words-long",
  // "3 Days 4 Hours 12 Minutes"
  "words-short",
  // "3D 4H 12M"
  "days-digital"
  // "3 Days 04:12:09"
]);
var CountdownTimeGranularitySchema = z.enum([
  "D_H_M_S",
  // Days, Hours, Minutes, Seconds
  "H_M_S",
  // Hours, Minutes, Seconds
  "D_H_M",
  // Days, Hours, Minutes
  "D_H",
  // Days, Hours
  "D",
  // Days only
  "H"
  // Hours only (total hours, rounded down)
]);
var DateTimeFormatSchema = z.object({
  timeFormat: z.enum(["hour12", "hour24"]).optional().nullable(),
  monthFormat: z.enum(["long", "short"]).optional().nullable(),
  dayFormat: z.enum(["long", "short"]).optional().nullable(),
  showTimezone: z.boolean().default(false).optional().nullable(),
  countdownFormatStyle: CountdownFormatStyleSchema.optional().nullable(),
  countdownTimeGranularity: CountdownTimeGranularitySchema.optional().nullable(),
  isTextFormat: z.boolean().default(false).optional().nullable()
});
var PenaltiesFormatSchema = z.object({
  separator: z.string().max(2).optional().nullable()
});
var PaintSchema = z.object({
  type: z.string(),
  color: z.object({
    r: z.number(),
    g: z.number(),
    b: z.number(),
    a: z.number()
  }).optional(),
  opacity: z.number().optional(),
  gradientStops: z.array(
    z.object({
      position: z.number(),
      color: z.object({
        r: z.number(),
        g: z.number(),
        b: z.number(),
        a: z.number()
      })
    })
  ).optional(),
  gradientHandlePositions: z.array(
    z.object({
      x: z.number(),
      y: z.number()
    })
  ).optional()
});
var AdElementTextSchema = AdElementBase.extend({
  type: textTypeName,
  data: z.object({
    content: z.string(),
    // {HOME_NAME} to beat {AWAY_NAME}
    isDate: z.boolean().optional().nullable(),
    isCountdown: z.boolean().optional().nullable(),
    dateFormat: z.string().optional().nullable(),
    fixture: z.string().optional().nullable(),
    dateDisplayOptions: DateTimeFormatSchema.optional().nullable(),
    odds: DisplayOptionsOddsFormatSchema.optional().nullable(),
    penaltiesFormat: PenaltiesFormatSchema.optional().nullable(),
    locale: z.string().optional().nullable(),
    timezone: z.string().optional().nullable(),
    betslip: z.object({
      optionId: z.string(),
      stake: z.number()
    }).optional().nullable(),
    dynamicFont: z.discriminatedUnion("enabled", [
      z.object({
        enabled: z.literal(true),
        maxFontSize: z.number(),
        minFontSize: z.number(),
        lineHeight: z.number(),
        multiLine: z.boolean()
      }),
      z.object({
        enabled: z.literal(false)
      })
    ]),
    style: z.object({
      color: z.string().nullable().optional(),
      stroke: z.string().nullable().optional(),
      strokeWeight: z.number().nullable().optional(),
      fontFamily: z.string().nullable().optional(),
      fontVariant: z.string().nullable().optional(),
      fontWeight: z.number().nullable().optional(),
      fontStyle: z.string().nullable().optional(),
      fontStretch: z.string().nullable().optional(),
      fontSize: z.number().nullable().optional(),
      textAlign: z.union([z.literal("left"), z.literal("center"), z.literal("right")]).nullable().optional(),
      textAlignVertical: z.union([z.literal("top"), z.literal("center"), z.literal("bottom")]).nullable().optional(),
      textCase: z.union([
        z.literal("none"),
        z.literal("uppercase"),
        z.literal("lowercase"),
        z.literal("capitalize")
      ]).nullable().optional(),
      letterSpacing: z.number().nullable().optional(),
      lineHeight: z.number().positive().nullable().optional(),
      transform: z.string().nullable().optional(),
      textDecoration: z.union([z.literal("underline"), z.literal("line-through")]).nullable().optional(),
      textShadow: z.string().nullable().optional(),
      fills: z.array(PaintSchema).nullable().optional()
    })
  })
});
var AdElementImageSchema = AdElementBase.extend({
  type: imageTypeName,
  data: z.object({
    content: z.string(),
    initialContent: z.string().optional().nullable(),
    isBrandLogo: z.boolean().optional()
  })
});
var AdElementTeamAssetSchema = AdElementBase.extend({
  type: teamAssetTypeName,
  data: z.object({
    content: z.string(),
    source: z.union([
      z.literal("HOME_ASSET"),
      z.literal("AWAY_ASSET"),
      z.literal("COMPETITOR_ASSET"),
      z.literal("OPPONENT_ASSET")
    ]).optional().nullable(),
    display: z.union([
      z.object({ type: z.literal("kit"), data: kitSchema }),
      z.object({
        type: z.literal("badge"),
        data: z.object({ content: z.string() })
      })
    ]).optional().nullable()
  })
});
var AdElementCasinoAssetSchema = AdElementBase.extend({
  type: casinoAssetTypeName,
  data: z.object({
    content: z.string(),
    source: z.union([
      z.literal("GAME_IMAGE"),
      z.literal("LANDSCAPE_IMAGE"),
      z.literal("PORTRAIT_IMAGE"),
      z.literal("SQUARE_IMAGE")
    ]).optional().nullable()
  })
});
var adElementVectorColor = z.object({
  value: z.string(),
  type: z.union([z.literal("PRIMARY"), z.literal("SECONDARY")]).nullable().default(null),
  source: z.union([
    z.literal("HOME_COLOR"),
    z.literal("AWAY_COLOR"),
    z.literal("COMPETITOR_COLOR"),
    z.literal("OPPONENT_COLOR")
  ]).nullable().default(null)
});
var AdElementVectorSchema = AdElementBase.extend({
  type: vectorTypeName,
  data: z.object({
    color: z.object({
      strokeWeight: z.number().nullable().optional(),
      fill: adElementVectorColor.nullable(),
      stroke: adElementVectorColor.nullable()
    }),
    content: z.string(),
    viewBox: z.object({
      height: z.number(),
      width: z.number()
    }),
    effectFilters: z.string().optional().nullable()
  })
});
var AdElementSchema = z.discriminatedUnion("type", [
  AdElementSVGSchema,
  AdElementTextSchema,
  AdElementImageSchema,
  AdElementTeamAssetSchema,
  AdElementCasinoAssetSchema,
  AdElementVectorSchema
]);
var CanonicalEasingSchema = z.tuple([z.number(), z.number(), z.number(), z.number()]);
var AnimatablePropertySchema = z.enum(["x", "y", "opacity", "rotation", "scale"]);
var AnimationKeyframeSchema = z.object({
  t: z.number(),
  value: z.number(),
  easing: CanonicalEasingSchema,
  // easing into this keyframe from the previous one
  effectId: z.string().optional().nullable()
});
var AnimationTrackSchema = z.object({
  targetId: z.string(),
  property: AnimatablePropertySchema,
  keyframes: z.array(AnimationKeyframeSchema)
});
var AnimationEffectSchema = z.object({
  id: z.string(),
  targetId: z.string(),
  presetId: z.string(),
  params: z.record(z.union([z.number(), z.string(), z.boolean()])).optional().nullable()
});
var AnimationTimelineSchema = z.object({
  duration: z.number(),
  fps: z.number(),
  loop: z.boolean()
});
var AnimationSchema = z.object({
  timeline: AnimationTimelineSchema,
  tracks: z.array(AnimationTrackSchema),
  effects: z.array(AnimationEffectSchema).optional()
});
var HierarchyTransformSchema = z.object({
  x: z.number().optional().nullable(),
  y: z.number().optional().nullable(),
  rotation: z.number().optional().nullable(),
  scale: z.number().optional().nullable(),
  opacity: z.number().optional().nullable()
});
var HierarchyNodeTypeSchema = z.enum(["GROUP", "FRAME"]);
var HierarchyNodeSchema = z.object({
  id: z.string(),
  type: HierarchyNodeTypeSchema,
  name: z.string(),
  parentId: z.string().nullable(),
  order: z.number(),
  locked: z.boolean().optional().nullable(),
  hidden: z.boolean().optional().nullable(),
  transform: HierarchyTransformSchema.optional().nullable()
});
var HierarchyLayoutEntrySchema = z.object({
  parentId: z.string().nullable(),
  order: z.number()
});
var HierarchySchema = z.object({
  nodes: z.array(HierarchyNodeSchema),
  layout: z.record(z.string(), HierarchyLayoutEntrySchema)
});
var AdTemplateDataSourceSchema = z.object({
  id: z.string(),
  type: SourceTypeSchema
});
var AdTemplateDataSourcesSchema = z.array(AdTemplateDataSourceSchema);
var DiplayOptionsTeamAssetTypeSchema = z.union([
  z.literal("BADGE"),
  z.literal("JERSEY"),
  z.literal("CUSTOM")
]);
var DiplayOptionsTeamAssetFallbackSchema = z.union([
  z.literal("NONE"),
  z.literal("BADGE"),
  z.literal("JERSEY")
]);
var DiplayOptionsTeamAssetSchema = z.object({
  type: DiplayOptionsTeamAssetTypeSchema,
  fallback: DiplayOptionsTeamAssetFallbackSchema
});
var AdTemplateDiplayOptionsSchema = z.object({
  teamAssets: DiplayOptionsTeamAssetSchema,
  odds: DisplayOptionsOddsFormatSchema.optional().nullable(),
  dateTimeFormat: DateTimeFormatSchema.optional().nullable(),
  penaltiesFormat: PenaltiesFormatSchema.optional().nullable()
});
var HoldingSchema = z.object({
  id: z.string(),
  holdingId: z.number(),
  name: z.string(),
  ownerId: z.string(),
  type: z.string(),
  dspId: z.number().nullable().optional()
});
var BusinessEntitySchema = z.object({
  id: z.string().optional(),
  businessEntityId: z.number(),
  name: z.string(),
  type: z.string(),
  f8OperatorStrings: z.array(z.string()),
  holdingId: z.number().nullable(),
  dspId: z.number().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional()
});
var ImportSourceTypeEnum = z.enum(["figma", "creatomate"]);
var AdTemplateTypeSchema = z.union([
  z.literal("CASINO"),
  z.literal("NASCAR"),
  z.literal("SPORTS"),
  z.literal("NBA"),
  z.literal("SOCCER"),
  z.literal("NFL")
]);
var AdTemplateCasinoImageOrientationSchema = z.union([z.literal("LANDSCAPE"), z.literal("PORTRAIT"), z.literal("SQUARE")]).optional().nullable();
var AdTemplateSchema = z.object({
  id: z.string().optional(),
  name: z.string(),
  brandId: z.string().optional().nullable(),
  brandKitId: z.string().optional().nullable(),
  figmaComponentId: z.string().optional().nullable(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  dataSources: z.array(AdTemplateDataSourceSchema),
  adElements: z.array(AdElementSchema),
  hierarchy: HierarchySchema.optional().nullable(),
  animation: AnimationSchema.optional().nullable(),
  displayOptions: AdTemplateDiplayOptionsSchema.optional().nullable(),
  thumbnail: z.string().optional().nullable(),
  isCompetitorFocused: z.boolean().default(false),
  stake: z.number().optional().nullable(),
  oddsFormat: z.string().optional().nullable(),
  supportedMarkets: z.array(z.string()).default([]),
  businessEntityId: z.number().optional().nullable(),
  userId: z.string().optional().nullable(),
  businessEntity: BusinessEntitySchema.optional().nullable(),
  importSourceType: ImportSourceTypeEnum,
  importSourceJSON: z.string().optional(),
  videoProjectId: z.string().optional().nullable(),
  sourceConfiguration: z.object({
    templateSourceType: AdTemplateTypeSchema,
    casinoImageOrientation: AdTemplateCasinoImageOrientationSchema
  }).optional().nullable()
});
function isDisplayOptionsOddsType(value) {
  return [
    "europeanDecimalOdds",
    "americanOdds",
    "decimalOdds",
    "fractionalOdds",
    "impliedProbability",
    "potentialWinnings"
  ].includes(value);
}
var isSVGElement = discriminate("type", "SVG");
var isTextElement = discriminate("type", "TEXT");
var isImageElement = discriminate("type", "IMAGE");
var isTeamAssetElement = discriminate("type", "TEAM_ASSET");
var isCasinoAssetElement = discriminate("type", "CASINO_ASSET");
var isVectorElement = discriminate("type", "VECTOR");
var FontFaceSchema = z.object({
  fontFamily: z.string(),
  weight: z.number(),
  style: z.string(),
  stretch: z.string().optional(),
  src: z.string()
});
var FontFaceExtendedSchema = FontFaceSchema.extend({
  fontFamilyId: z.string().optional(),
  variant: z.string().optional()
});
var FigmaComponentSizeSchema = z.object({
  width: z.number(),
  height: z.number()
});
var FigmaComponentSchema = z.object({
  id: z.string(),
  name: z.string(),
  figmaId: z.string(),
  conceptId: z.string().nullable(),
  size: FigmaComponentSizeSchema.nullable(),
  fileId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  svg: z.string().nullable(),
  svgUrl: z.string().nullable(),
  thumbnail: z.string().nullable(),
  svgElement: AdElementSVGSchema.nullable(),
  textElements: z.array(AdElementTextSchema).default([]),
  imageElements: z.array(AdElementImageSchema).default([]),
  vectorElements: z.array(AdElementVectorSchema).default([])
});
var FigmaComponentsListOutputSchema = z.object({
  components: z.array(FigmaComponentSchema)
});

// src/Recommenders/TeamColors.ts
import { deltaE } from "color-delta-e";
function getJerseyColor(arr, teamCompare) {
  let color = getColor(arr, teamCompare);
  if (color === void 0 || isString(color)) {
    return {};
  }
  return Object.entries({ ...color, background: color.base }).reduce((acc, [key, value]) => {
    acc[toCamelCase(key)] = value;
    return acc;
  }, {});
}
function getHeadwearColor(main, fallbacks) {
  if (main.primary && main.secondary) {
    return { background: main.primary, accent: main.secondary };
  }
  let color = getColor(fallbacks);
  if (color === void 0)
    return {};
  const colorIndex = fallbacks.filter((v) => v !== void 0).findIndex((v) => v === color);
  let accent = colorIndex < fallbacks.length - 1 ? fallbacks[colorIndex + 1] : "#fff";
  color = isString(color) ? color : color.base;
  accent = isString(accent) ? accent : accent?.base || "#fff";
  return {
    background: color,
    accent
  };
}
function getColor(arr, teamCompare) {
  let primary = void 0;
  const thresholds = {
    team: 35
  };
  for (const color of arr) {
    let current = color;
    if (current === void 0)
      continue;
    if (!isString(current)) {
      if (current?.base === void 0)
        continue;
      current = current.base;
    }
    if (teamCompare) {
      const teamDif = Math.floor(deltaE(teamCompare, current));
      if (teamDif < thresholds.team)
        continue;
    }
    primary = color;
    break;
  }
  return primary;
}
function isString(possibleString) {
  return typeof possibleString === "string";
}
var toCamelCase = (str) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};
function getColorByType(competitor, type) {
  if (type === "PRIMARY" && competitor.colors?.primary) {
    return competitor.colors.primary;
  }
  if (type === "SECONDARY" && competitor.colors?.secondary) {
    return competitor.colors.secondary;
  }
  let color = getColor([
    competitor.colors?.home,
    competitor.colors?.away,
    competitor.colors?.third
  ]);
  color = isString(color) ? color : color?.base;
  if (typeof color === "string")
    return color || "";
  return "";
}
function getVectorColor(vectorColorSource, vectorColorType, competitors) {
  switch (vectorColorSource) {
    case "HOME_COLOR":
      return getColorByType(competitors.home, vectorColorType);
    case "AWAY_COLOR":
      return getColorByType(competitors.away, vectorColorType);
  }
}
function getTeamColors(competitors) {
  return {
    AWAY_COLOR: {
      PRIMARY: getVectorColor("AWAY_COLOR", "PRIMARY", competitors),
      SECONDARY: getVectorColor("AWAY_COLOR", "SECONDARY", competitors)
    },
    HOME_COLOR: {
      PRIMARY: getVectorColor("HOME_COLOR", "PRIMARY", competitors),
      SECONDARY: getVectorColor("HOME_COLOR", "SECONDARY", competitors)
    }
  };
}

// src/Recommenders/Player.ts
var StatType = /* @__PURE__ */ ((StatType2) => {
  StatType2["POINTS"] = "POINTS";
  StatType2["REBOUNDS"] = "REBOUNDS";
  StatType2["ASSISTS"] = "ASSISTS";
  StatType2["STRIKEOUTS"] = "STRIKEOUTS";
  StatType2["HITS"] = "HITS";
  StatType2["PASSING_YARDS"] = "PASSING_YARDS";
  StatType2["RUSHING_YARDS"] = "RUSHING_YARDS";
  StatType2["RECEIVING_YARDS"] = "RECEIVING_YARDS";
  return StatType2;
})(StatType || {});
var marketStatIdMap = {
  chalkboard: {
    POINTS: "sr:market:921",
    ASSISTS: "sr:market:922",
    REBOUNDS: "sr:market:923",
    STRIKEOUTS: "sr:market:925",
    HITS: "sr:market:9000",
    PASSING_YARDS: "sr:market:914",
    RUSHING_YARDS: "sr:market:918",
    RECEIVING_YARDS: "sr:market:919"
  }
};
var statNamePatterns = {
  ["PASSING_YARDS" /* PASSING_YARDS */]: /passing yards/i,
  ["RUSHING_YARDS" /* RUSHING_YARDS */]: /rushing yards/i,
  ["RECEIVING_YARDS" /* RECEIVING_YARDS */]: /receiving yards/i
};
function formatMarketStatLookup(statType, operator) {
  return `operator ${operator}, id ${marketStatIdMap[operator]?.[statType] ?? "unmapped"}`;
}
function getPlayersFromMarket(betData) {
  if (!betData.options)
    return [];
  return Object.values(betData.options).map((option) => {
    const player = {
      id: option.id,
      odds: option.odds,
      wasOdds: option.wasOdds,
      name: {
        full: option.name.full,
        short: option.name.short,
        micro: option.name.micro
      },
      marketID: option.marketID,
      promoText: option.promoText || "",
      playerProperties: option.playerProperties || [],
      competitor: option.competitor || {}
    };
    return player;
  });
}
function getPlayers(betData) {
  return getPlayersFromMarket(betData);
}
function getPlayerPropPlayers(betData) {
  const playerPropMarketIds = new Set(
    Object.entries(betData.markets ?? {}).filter(([, market]) => market.marketType === "Player Props").flatMap(([marketKey, market]) => {
      const ids = [market.marketId, marketKey].filter(Boolean);
      return [...new Set(ids)];
    })
  );
  return getPlayersFromMarket(betData).filter(
    (player) => playerPropMarketIds.has(player.marketID) && player.playerProperties.length > 0
  );
}
function getEventIdForPlayers(betData, players) {
  if (players.length === 0)
    return void 0;
  return betData.markets[players[0]?.marketID || ""]?.eventId || void 0;
}
function filterPlayersByCompetitor(betData, players, side) {
  if (players.length === 0)
    return [];
  const eventId = getEventIdForPlayers(betData, players);
  if (!eventId)
    return [];
  const event = betData.events[eventId];
  if (!event?.competitors)
    return [];
  const competitorId = side === "home" ? event.competitors.home?.competitor_id : event.competitors.away?.competitor_id;
  if (!competitorId)
    return [];
  return players.filter((player) => player.competitor.competitor_id?.includes(competitorId));
}
function getHomePlayers(betData) {
  const players = getPlayerPropPlayers(betData);
  if (players.length === 0)
    return [];
  return filterPlayersByCompetitor(betData, players, "home");
}
function getAwayPlayers(betData) {
  const players = getPlayerPropPlayers(betData);
  if (players.length === 0)
    return [];
  return filterPlayersByCompetitor(betData, players, "away");
}
function findPlayerProperty(player, operator, statType) {
  const statId = marketStatIdMap[operator]?.[statType];
  if (statId) {
    const byId = player.playerProperties.find((prop) => prop.id === statId);
    if (byId)
      return byId;
  }
  const pattern = statNamePatterns[statType];
  return pattern ? player.playerProperties.find((prop) => pattern.test(prop.name)) : void 0;
}
function playerHasStat(player, operator, statType) {
  return findPlayerProperty(player, operator, statType) != null;
}
function getMostTotalPlayer(players, operator, statType, ordinal = 0) {
  if (players.length === 0)
    throw new Error("No players provided");
  const playersWithStat = players.filter((player) => playerHasStat(player, operator, statType));
  if (playersWithStat.length === 0) {
    throw new Error(
      `No players have ${statType} data (${formatMarketStatLookup(statType, operator)}). This data point is unavailable for this event \u2014 likely a sport mismatch.`
    );
  }
  if (ordinal < 0 || ordinal >= playersWithStat.length) {
    throw new Error(
      `Cannot fulfil ordinal ${ordinal} for ${statType}: only ${playersWithStat.length} player(s) with that stat`
    );
  }
  const sortedPlayers = [...playersWithStat].sort((playerA, playerB) => {
    const propA = findPlayerProperty(playerA, operator, statType);
    const propB = findPlayerProperty(playerB, operator, statType);
    const av = parseFloat(propA?.seperator_text || "0");
    const bv = parseFloat(propB?.seperator_text || "0");
    if (bv !== av)
      return bv - av;
    const aOdds = getOverDecimalOdds(propA);
    const bOdds = getOverDecimalOdds(propB);
    if (aOdds !== bOdds)
      return aOdds - bOdds;
    return playerA.id.localeCompare(playerB.id);
  });
  return sortedPlayers[ordinal];
}
function getMostTotal(player, operator, statType) {
  const prop = findPlayerProperty(player, operator, statType);
  if (!prop) {
    throw new Error(
      `Player ${player.id} has no ${statType} data (${formatMarketStatLookup(statType, operator)})`
    );
  }
  return prop.seperator_text || "0";
}
function getOverDecimalOdds(prop) {
  const over = prop?.options?.find((option) => option.label === "Over");
  return getDecimalOdds(over?.odds?.odds ?? []);
}
function getDecimalOdds(odds) {
  if (!isValidOdds(odds)) {
    return Number.POSITIVE_INFINITY;
  }
  const decimal = odds[0] / odds[1] + 1;
  return parseFloat(decimal.toFixed(2));
}
function isValidOdds(odds) {
  return odds[0] > 0 && odds[1] > 0;
}

// src/Console.ts
var Console_exports = {};
__export(Console_exports, {
  stringIsOddType: () => stringIsOddType
});
function stringIsOddType(str) {
  const oddsTypes = [
    "americanOdds",
    "decimalOdds",
    "europeanDecimalOdds",
    "fractionalOdds",
    "impliedProbability",
    "potentialWinnings"
  ];
  return oddsTypes.find((oT) => oT === str) !== void 0;
}

// src/VideoTemplate.ts
var VideoModificationSchema = z.discriminatedUnion("type", [
  AdElementTextSchema.partial({
    id: true,
    position: true,
    size: true
  }),
  AdElementTeamAssetSchema.partial({
    id: true,
    position: true,
    size: true
  })
]);
var VideoTemplateSchema = z.object({
  provider: z.string(),
  providerId: z.string(),
  name: z.string(),
  modifications: z.array(VideoModificationSchema).default([]),
  dataSources: z.array(AdTemplateDataSourceSchema).default([]),
  displayOptions: AdTemplateDiplayOptionsSchema.partial({
    teamAssets: true
  }).optional()
});
var VideoTemplatesSchema = z.object({
  templates: z.array(VideoTemplateSchema).default([])
});

// src/Creatomate/index.ts
var Creatomate_exports = {};
__export(Creatomate_exports, {
  enrichImageElementsWithAssetURL: () => enrichImageElementsWithAssetURL,
  transformCreatomateElementsToAdElements: () => transformCreatomateElementsToAdElements
});

// src/Creatomate/types.ts
var CreatomateElementType = {
  COMPOSITION: "composition",
  IMAGE: "image",
  TEXT: "text"
};
function isTextElement2(element) {
  return element.type === CreatomateElementType.TEXT;
}
function isImageElement2(element) {
  return element.type === CreatomateElementType.IMAGE;
}
function isCompositionElement(element) {
  return element.type === CreatomateElementType.COMPOSITION;
}
function isCreatomateElement(element) {
  return isTextElement2(element) || isImageElement2(element) || isCompositionElement(element);
}

// src/Creatomate/utils.ts
var getStringProperty = (property) => {
  return typeof property === "string" ? property : null;
};
var getNumberProperty = (property) => {
  return typeof property === "number" ? property : null;
};

// src/Creatomate/transform/text.ts
var transformText = (textElement) => {
  const name = textElement.name ?? "";
  const text = typeof textElement.text === "string" ? textElement.text : "";
  const content = hasInlineTokens(name) ? name : text;
  return {
    type: "TEXT",
    name,
    id: textElement.id?.toString() ?? "",
    sources: [],
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    size: {
      height: 0,
      width: 0
    },
    data: {
      content,
      dynamicFont: {
        enabled: true,
        maxFontSize: 0,
        minFontSize: 0,
        lineHeight: 0,
        multiLine: false
      },
      style: {
        color: getStringProperty(textElement.fillColor),
        stroke: getStringProperty(textElement.strokeColor),
        strokeWeight: Number(textElement.strokeWidth) || null,
        fontFamily: getStringProperty(textElement.fontFamily),
        fontWeight: getNumberProperty(textElement.fontWeight),
        fontStyle: getStringProperty(textElement.fontStyle),
        fontSize: Number(textElement.fontSize) || null,
        letterSpacing: Number(textElement.letterSpacing) || null,
        lineHeight: Number(textElement.lineHeight) || null,
        transform: getStringProperty(textElement.textTransform)
      }
    }
  };
};

// src/Creatomate/transform/image.ts
var transformImage = (element) => {
  const source = getStringProperty(element.source) ?? "";
  return {
    type: "IMAGE",
    name: element.name ?? "",
    id: element.id?.toString() ?? "",
    sources: [],
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    size: {
      height: 0,
      width: 0
    },
    data: {
      content: source,
      initialContent: source
    }
  };
};
var enrichImageElementsWithAssetURL = async (elements, imageLinkGetter) => {
  const es = elements.map((e) => enrichElementWithAssetUrl(e, imageLinkGetter));
  return Promise.all(es);
};
var enrichElementWithAssetUrl = async (element, imageLinkGetter) => {
  const sourceId = element.data.initialContent ?? element.data.content;
  if (sourceId.startsWith("http")) {
    return element;
  }
  const link = await imageLinkGetter.getAssetURL(sourceId);
  element.data.content = link;
  element.data.initialContent = link;
  return element;
};

// src/Creatomate/transform/index.ts
var transformCreatomateElementsToAdElements = (elements) => {
  return elements.filter(isCreatomateElement).flatMap(applyTransform);
};
var applyTransform = (e) => {
  if (isTextElement2(e)) {
    return transformText(e);
  }
  if (isImageElement2(e)) {
    return transformImage(e);
  }
  if (isCompositionElement(e)) {
    return transformComposition(e);
  }
  console.warn(`Unsupported element type: ${e["type"]}`);
  return [];
};
function transformComposition(element) {
  const elements = element.elements ?? [];
  return elements.filter(isCreatomateElement).flatMap(applyTransform);
}

// src/DataSource.ts
var DataSource2 = /* @__PURE__ */ ((DataSource3) => {
  DataSource3["SPORTS"] = "SPORTS";
  DataSource3["SPORTS_MOMENTS"] = "SPORTS_MOMENTS";
  DataSource3["NASCAR"] = "NASCAR";
  DataSource3["CASINO"] = "CASINO";
  return DataSource3;
})(DataSource2 || {});
var DataSourceDisplayNames = {
  ["SPORTS" /* SPORTS */]: "Sports Odds",
  ["SPORTS_MOMENTS" /* SPORTS_MOMENTS */]: "Sports Moments",
  ["NASCAR" /* NASCAR */]: "Nascar",
  ["CASINO" /* CASINO */]: "Casino"
};
var VideoTagDataSources = [
  "SPORTS" /* SPORTS */,
  "SPORTS_MOMENTS" /* SPORTS_MOMENTS */,
  "NASCAR" /* NASCAR */
];

// src/BrandVariable.ts
var BrandVariable = /* @__PURE__ */ ((BrandVariable2) => {
  BrandVariable2["PRIMARY_FONT"] = "primary_font";
  BrandVariable2["SECONDARY_FONT"] = "secondary_font";
  BrandVariable2["PRIMARY_COLOR"] = "primary_color";
  BrandVariable2["SECONDARY_COLOR"] = "secondary_color";
  BrandVariable2["LOGO"] = "logo";
  BrandVariable2["BRAND_LOGO"] = "brand_logo";
  return BrandVariable2;
})(BrandVariable || {});
var BRAND_VARIABLE_VALUES = Object.values(BrandVariable);
function isBrandVariable(value) {
  return BRAND_VARIABLE_VALUES.includes(value);
}
var IMAGE_VARIABLE_MAPPINGS = {
  BRAND_LOGO: "brand_logo" /* BRAND_LOGO */,
  LOGO: "logo" /* LOGO */
  // Add more mappings as needed, e.g.:
  // SPONSOR_LOGO: 'sponsor_logo',
};

// src/ContentType.ts
var ContentTypeSchema = z.enum(["BRANDED_INSIGHT"]);
var CONTENT_TYPE_DATA_POINTS = {
  BRANDED_INSIGHT: ["BRANDED_INSIGHT"]
};

// src/messaging.ts
var BRANDED_INSIGHT_MESSAGE_TYPE = "adflow:set-branded-insight";
var RENDER_ERROR_MESSAGE_TYPE = "adflow:render-error";

// src/Direct/SportsMoments/schedule.ts
var HOUR_MS = 60 * 60 * 1e3;
var MINUTE_MS = 60 * 1e3;
var SPORTS_MOMENTS_STAGES_ORDERED = ["pre", "live", "post"];
var SPORTS_MOMENTS_STAGE_SCHEDULE_OFFSETS_MS = {
  pre: { start: -48 * HOUR_MS, end: 6 * HOUR_MS },
  // Starts 48 hours before kickoff, ends 6 hours after
  live: { start: -10 * MINUTE_MS, end: 12 * HOUR_MS },
  // Starts 10 minutes before kickoff, ends 12 hours after
  post: { start: 1 * HOUR_MS, end: 30 * HOUR_MS }
  // Starts 1 hour after kickoff, ends 30 hours after
};
var sportsMomentsEndDate = (kickoff, latestStage) => new Date(kickoff.getTime() + SPORTS_MOMENTS_STAGE_SCHEDULE_OFFSETS_MS[latestStage].end);

// src/DoohBundle.ts
var DOOH_BUNDLE_MANIFEST_VERSION = "1";
var DOOH_HTML_COMPATIBILITY_VERSION = "1";
var DOOH_RENDERER_DEPENDENCIES_PATH = "/internal/dooh-bundle/dependencies";
var DOOH_RENDERER_PROFILES = ["standard", "direct"];

// src/LocalDevelopment.ts
function isLocalDevelopment(policy) {
  return policy.environment === "local" && policy.enabled === "true";
}
function isLoopbackUrl(value) {
  try {
    return ["localhost", "127.0.0.1", "[::1]"].includes(new URL(value).hostname);
  } catch {
    return false;
  }
}
function isAllowedDoohAssetUrl(value, policy) {
  try {
    const url = new URL(value);
    if (url.username || url.password)
      return false;
    if (url.protocol === "https:")
      return true;
    return url.protocol === "http:" && isLocalDevelopment(policy) && isLoopbackUrl(value) && (policy.httpOrigins || "").split(",").map((origin) => origin.trim()).includes(url.origin);
  } catch {
    return false;
  }
}
export {
  AdElementCasinoAssetSchema,
  AdElementDataSourceSchema,
  AdElementImageSchema,
  AdElementSVGSchema,
  AdElementSchema,
  AdElementTeamAssetSchema,
  AdElementTextSchema,
  AdElementVectorSchema,
  AdTemplateCasinoImageOrientationSchema,
  AdTemplateDataSourcesSchema,
  AdTemplateDiplayOptionsSchema,
  AdTemplateSchema,
  AdTemplateTypeSchema,
  AdflowAPI_exports as AdflowAPI,
  AnimatablePropertySchema,
  AnimationEffectSchema,
  AnimationKeyframeSchema,
  AnimationSchema,
  AnimationTimelineSchema,
  AnimationTrackSchema,
  BRANDED_INSIGHT_MESSAGE_TYPE,
  BRAND_VARIABLE_VALUES,
  BrandVariable,
  BusinessEntitySchema,
  CONTENT_TYPE_DATA_POINTS,
  CanonicalEasingSchema,
  Console_exports as Console,
  ContentTypeSchema,
  CountdownFormatStyleSchema,
  CountdownTimeGranularitySchema,
  Creatomate_exports as Creatomate,
  DOOH_BUNDLE_MANIFEST_VERSION,
  DOOH_HTML_COMPATIBILITY_VERSION,
  DOOH_RENDERER_DEPENDENCIES_PATH,
  DOOH_RENDERER_PROFILES,
  DataSource2 as DataSource,
  DataSourceDisplayNames,
  Datasources_exports3 as Datasources,
  DateTimeFormatSchema,
  DiplayOptionsTeamAssetSchema,
  DisplayOptionsOddsFormatSchema,
  FigmaComponentSchema,
  FigmaComponentsListOutputSchema,
  FontFaceSchema,
  HierarchyLayoutEntrySchema,
  HierarchyNodeSchema,
  HierarchyNodeTypeSchema,
  HierarchySchema,
  HierarchyTransformSchema,
  HoldingSchema,
  IMAGE_VARIABLE_MAPPINGS,
  INLINE_TOKEN_REGEX,
  MatchWinner_exports as MatchWinnerDataSource,
  NFLCompetition,
  NFLStages,
  PenaltiesFormatSchema,
  RENDER_ERROR_MESSAGE_TYPE,
  Datasources_exports as RecommendersDataSources,
  SPORTS_MOMENTS_STAGES_ORDERED,
  SPORTS_MOMENTS_STAGE_SCHEDULE_OFFSETS_MS,
  SoccerCompetition,
  SoccerStages,
  StatType,
  TeamAssetElement_exports as TeamAssetTypes,
  VideoTagDataSources,
  VideoTemplateSchema,
  VideoTemplatesSchema,
  appendSvgIfExtensionlessForCreatomate,
  buildCustomAssetContentUrl,
  discriminate,
  extractInlineTokens,
  getAwayPlayers,
  getColor,
  getHeadwearColor,
  getHomePlayers,
  getJerseyColor,
  getMostTotal,
  getMostTotalPlayer,
  getPlayerPropPlayers,
  getPlayers,
  getTeamColors,
  hasInlineTokens,
  isAllowedDoohAssetUrl,
  isBrandVariable,
  isCasinoAssetElement,
  isDisplayOptionsOddsType,
  isImageElement,
  isLocalDevelopment,
  isLoopbackUrl,
  isSVGElement,
  isTeamAssetElement,
  isTextElement,
  isVectorElement,
  nflStageSelectOptions,
  notEmpty,
  parseElementName,
  soccerStageSelectOptions,
  sportsMomentsEndDate,
  stringIsOfUnionType
};
